import React, { useEffect, useState, useRef } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import { useParams } from "react-router-dom";
import '../css/ViewRequisition.css';
import Sidebar from './Sidebar';
import Select from "react-select";
import '../css/ReviewRequisition.css';
import DisapproveButton from './DisapproveButton';
import { DateTime } from "luxon";
import LoadingOverlay from "./LoadingOverlay";
import PopupModal from "./PopupModal";
import { faCheckCircle, faTimesCircle, faPaperPlane, faHistory, faWifi, faDollarSign, faUser, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ExportExcelButton from './ExportExcelButton';


const districts = [
  "Balaka", "Blantyre", "Chikwawa", "Chiradzulu", "Chitipa", "Dedza", "Dowa", "Karonga", "Kasungu",
  "Likoma", "Lilongwe", "Machinga", "Mangochi", "Mchinji", "Mulanje", "Mwanza", "Mzimba", "Neno",
  "Nkhata Bay", "Nkhotakota", "Nsanje", "Ntcheu", "Ntchisi", "Phalombe", "Rumphi", "Salima", "Thyolo", "Zomba"
];

const ReviewRequisition = () => {

  const [submitterSignaturePath, setSubmitterSignaturePath] = useState(null);
  //For the toast notification
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState('success');
  
  const [blastingTotalTotal, setBlastingTotalTotal] = useState(0);
  const [blastingCostItems, setBlastingCostItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  
  // Add this with your other modal state declarations
  const [showSurrenderForwardSuccess, setShowSurrenderForwardSuccess] = useState(false);
  const [forwardedToReviewerName, setForwardedToReviewerName] = useState('');
  // Add this with your other state declarations
  const [claimStatus, setClaimStatus] = useState({
      isClaimedByMe: false,
      claimedById: null,
      claimedByName: null,
      claimedByDate: null
  });
  const theUserType = localStorage.getItem('userType');
  const theUserId = localStorage.getItem('userId');  
  const fullName = localStorage.getItem('fullName') || "Name";
  const token = localStorage.getItem("token");
  const isSurrenderReviewer = theUserType === "Surrender Reviewer";
  const signatureFilePath = localStorage.getItem("signatureFilePath");
  const staticBaseUrl = process.env.REACT_APP_STATIC_BASE_URL;
  
  const signatureUrl = signatureFilePath
    ? `${staticBaseUrl}/${signatureFilePath}`
    : `${staticBaseUrl}/signatures/default-signature.jpg`;


  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const fromPath = location.state?.from || '/staff-requisitions';
  const { requisitionID } = useParams(); 
 


  const [forwardTo, setForwardTo] = useState("");
  const [forwardedToName, setForwardedToName] = useState(null);
  const [showForwardConfirm, setShowForwardConfirm] = useState(false);
  const [showForwardSuccess, setShowForwardSuccess] = useState(false);


  const [eligibleReviewers, setEligibleReviewers] = useState([]);
  
  const forwardName = eligibleReviewers.find(u => u.id === forwardTo)?.fullName;
  const selectedUser = eligibleReviewers.find(u => u.id === forwardTo);


  const [selectedReviewerId, setSelectedReviewerId] = useState('');
  const [showselectNextReviewerModal, setShowselectNextReviewerModal] = useState(false);
  const [showDisbursedModal, setShowDisbursedModal] = useState(false);
  
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState({ audits: [], reviews: [] });
  const [combinedHistory, setCombinedHistory] = useState([]);
  
  
  const [reviewerNumber, setReviewerNumber] = useState(null);

  const [showSurrenderCheckbox, setShowSurrenderCheckbox] = useState(false);
  const [isSurrenderChecked, setIsSurrenderChecked] = useState(false);
  const [selectedSurrenderReviewer, setSelectedSurrenderReviewer] = useState('');

  // Add these state variables for Print and Export functionality
  const contentRef = useRef();
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);

  // State variables needed for ExportExcelButton
  const [formArray, setFormArray] = useState([]);
  const [exportCostItems, setExportCostItems] = useState([]);
  const [exportFormData, setExportFormData] = useState({});

const fetchRequisitionDetails = async () => {
    try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}`, {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }
        });        
        console.log("=== FETCHED REQUISITION DATA ===");
        console.log("Full data:", data);
        console.log("ClaimedBySurrenderReviewerId from backend:", data.claimedBySurrenderReviewerId);
        console.log("Status from backend:", data.status);
        console.log("CurrentReviewerNumber from backend:", data.currentReviewerNumber);
        console.log("NextReviewerId from backend:", data.nextReviewerId);
        
        // ALWAYS check claim status for ALL user types
        try {
            const claimResponse = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/is-claimed-by-me`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log("Claim status API response:", claimResponse.data);
            
            setClaimStatus({
                isClaimedByMe: claimResponse.data.isClaimedByMe || false,
                claimedById: claimResponse.data.claimedById || null,
                claimedByName: claimResponse.data.claimedByName || null,
                claimedByDate: claimResponse.data.claimedByDate || null
            });
        } catch (claimError) {
            console.error('Error checking claim status:', claimError);
            // If error, assume no claim
            setClaimStatus({
                isClaimedByMe: false,
                claimedById: null,
                claimedByName: null,
                claimedByDate: null
            });
        }


        const formattedPairs = Array.isArray(data.districtAndAreaProgramPairs)
          ? data.districtAndAreaProgramPairs.map(pair => ({
              id: pair.id,
              district: pair.district,
              areaProgram: pair.areaProgram,
              requisitionID: pair.requisitionID
              }))
          : [];

          setDistrictAndAreaProgramPairs(formattedPairs);
          setRequisition(data);

          // Fetch submitter's signature
          if (data.userID) {
              try {
                  const userResponse = await axios.get(
                      `${process.env.REACT_APP_API_BASE_URL}/users/${data.userID}`,
                      { headers: { Authorization: `Bearer ${token}` } }
                  );
                  setSubmitterSignaturePath(userResponse.data.signatureFilePath);
              } catch (error) {
                  console.error('Error fetching submitter signature:', error);
                  setSubmitterSignaturePath(null);
              }
          }

          setFormData(prev => ({
              ...prev,
              staffName: data.staffName || '',
              staffLevel: data.staffLevel || '',
              supervisorName: data.supervisorName || '',
              userType: data.userType || '',
              userId: data.userID || '',
              from: data.from ? formatDateForInput(data.from) : '',
              to: data.to ? formatDateForInput(data.to) : '',
              activityName: data.activityName || '',
              activityPurpose: data.activityPurpose || '',
              targetClient: data.targetClient || '',
              expectedImpact: data.expectedImpact || '',
              country: data.country || '',
              district: data.district || '',
              areaProgram: data.areaProgram || '',
              hubOffice: data.hubOffice || '',
              status: data.status || '',
              projectCode: data.projectCode || '',
              projectName: data.projectName || '',
              budgetLineCode: data.budgetLineCode || '',
              payMode: data.payMode || '',
              bankName: data.bankName || '',
              branch: data.branch || '',
              accountNumber: data.accountNumber || '',
              phoneNumber: data.phoneNumber || '',
              requisitionDate: data.requisitionDate || '',
              districtAndAreaProgramPairs: formattedPairs,
              costDrivers: data.costDrivers || [],
              blastingCostDrivers: data.blastingCostDrivers || [],
              currentReviewerNumber: data.currentReviewerNumber,
              submitterReviewerNumber: data.submitterReviewerNumber,
              requesterComment: data.requesterComment || data.RequesterComment || '',
              claimedBySurrenderReviewerId: data.claimedBySurrenderReviewerId || null,
              nextReviewerId: data.nextReviewerId || null 
          }));

          setCostItems(
              Array.isArray(data.costDrivers)
              ? data.costDrivers.map(driver => ({
                  id: driver.id,
                  costDriver: driver.costDriver,
                  justification: driver.justification || '',
                  quantity: driver.quantity || 0,
                  unitPrice: driver.unitPrice || 0,
                  total: driver.total || 0,
                  supportDocuments: driver.supportDocuments || '',
                  isCustom: false,
                  customCostDriver: ''
                  }))
              : []
          );

      setBlastingCostItems(
        Array.isArray(data.blastingCostDrivers)
        ? data.blastingCostDrivers.map(driver => ({
            id: driver.id,
            costDriver: driver.costDriver || '',
            justification: driver.justification || '',
            quantity: driver.quantity || 0,
            unitPrice: driver.unitPrice || 0,
            total: driver.total || 0,
            supportDocuments: driver.supportDocuments || '',
            isCustom: false,  // Always false on load
            customCostDriver: ''
            }))
        : []
    );

    // Set exportFormData for ExportExcelButton
setExportFormData({
  staffName: data.staffName || '',
  staffLevel: data.staffLevel || '',
  supervisorName: data.supervisorName || '',
  activityName: data.activityName || '',
  activityPurpose: data.activityPurpose || '',
  from: data.from || '',
  to: data.to || '',
  targetClient: data.targetClient || '',
  expectedImpact: data.expectedImpact || '',
  projectCode: data.projectCode || '',
  budgetLineCode: data.budgetLineCode || '',
  projectName: data.projectName || '',
  payMode: data.payMode || '',
  bankName: data.bankName || '',
  branch: data.branch || '',
  accountNumber: data.accountNumber || '',
  phoneNumber: data.phoneNumber || '',
  requisitionDate: data.requisitionDate || '',
  requisitionID: data.requisitionID || '',
  status: data.status || '',
  districtAndAreaProgramPairs: data.districtAndAreaProgramPairs || []
});

// Set exportCostItems for ExportExcelButton
if (data.costDrivers && data.costDrivers.length > 0) {
  setExportCostItems(data.costDrivers.map(driver => ({
    costDriver: driver.costDriver || driver.customCostDriver || '',
    justification: driver.justification || '',
    quantity: driver.quantity || '',
    unitPrice: driver.unitPrice || '',
    total: driver.total || '',
    supportDocuments: driver.supportDocuments || '',
    isCustom: !!driver.customCostDriver,
    customCostDriver: driver.customCostDriver || ''
  })));
}

      } catch (error) {
          console.error('Error fetching requisition details:', error);
      }
  };


useEffect(() => {
    fetchRequisitionDetails();
  }, [requisitionID]);

  const [formData, setFormData] = useState(() => {
                    
    return {
        country: '',
        district: '',
        staffName: '',
        staffLevel: '',
        projectCode: '',
        activityPurpose: '',
        projectName: '',
        from: '',
        to: '',
        activityName: '',
        hubOffice: '',
        areaProgram: '',
        supervisorName: '',
        budgetLineCode: '',
        targetClient: '',
        expectedImpact: '',
        userType: '',
        userId: '',
        payMode: '',
        bankName:'',
        branch:'',
        accountNumber: '',
        phoneNumber: '',
        requisitionDate: '', 
        status: '',  

        costDrivers: [{ costDriver: '', customCostDriver: '' }], 
        blastingCostDrivers: [],
        districtAndAreaProgramPairs: [
          { id: null, district: "", areaProgram: "" }
        ],  
        nextReviewerId: '',
        currentReviewerNumber: null,    
        submitterReviewerNumber: null,
        requesterComment: ''   
      };
    });

  const [costDriverOptions, setCostDriverOptions] = useState([]);


  const [isClaimedByMe, setIsClaimedByMe] = useState(false);
  const amReviewer = reviewerNumber === formData.currentReviewerNumber;
  const pendingClaimable =
      !amReviewer &&                            
      reviewerNumber != null &&                 
      reviewerNumber !== formData.currentReviewerNumber;

  // Determine if form should be editable
// Update your isEditable logic
// Replace your current isEditable logic with this:
// Determine if form should be editable
const isEditable = (() => {
    console.log("=== EDITABLE LOGIC DEBUG ===");
    console.log("claimStatus.isClaimedByMe:", claimStatus.isClaimedByMe);
    console.log("formData.currentReviewerNumber === reviewerNumber:", formData.currentReviewerNumber === reviewerNumber);
    console.log("claimStatus.claimedById:", claimStatus.claimedById);
    
    // If user has claimed it (via surrender or regular claim)
    if (claimStatus.isClaimedByMe) {
        console.log("Editable: User has claimed it");
        return true;
    }
    
    // If user is the current reviewer in regular workflow AND no surrender claim
    if (formData.currentReviewerNumber === reviewerNumber && !claimStatus.claimedById) {
        console.log("Editable: User is current reviewer, no surrender claim");
        return true;
    }
    
    // If user should have it (based on reviewer number) but surrender has it
    if (formData.currentReviewerNumber === reviewerNumber && 
        claimStatus.claimedById && 
        claimStatus.claimedById !== theUserId) {
        console.log("Editable: User should have it but surrender has it");
        return false; // NOT editable - needs to click "take" button first
    }
    
    console.log("Not editable");
    return false;
})();

// ===================
  const isRequisitionAwaitingReview = formData.status === "Submitted" || 
                                      formData.status === "Reviewed by" || 
                                      formData.status?.startsWith("Reviewed by");


  const showClaimButton = 
    // Show if someone else has claimed it (for BOTH Reviewer and Surrender Reviewer)
    (claimStatus.claimedById && !claimStatus.isClaimedByMe) ||
    // For regular reviewers in normal workflow (no one has claimed it yet)
    (!isClaimedByMe && pendingClaimable && !isSurrenderReviewer && formData.currentReviewerNumber !== -1 && !claimStatus.claimedById) || 
    // For surrender reviewers when requisition is available (no one has claimed it)
    (isSurrenderReviewer && isRequisitionAwaitingReview && !claimStatus.claimedById);
  // ==========================================


  const [showCheckedRequisitionModal, setShowCheckedRequisitionModal] = useState(false);
  const [showReviewedRequisitionModal, setShowReviewedRequisitionModal] = useState(false);
  const [showApprovedModal, setShowApprovedModal] = useState(false);
  const [showNoInternetModal, setShowNoInternetModal] = useState(false);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showNextReviewerBeforeApprovingModal, setShowNextReviewerBeforeApprovingModal] = useState(false);
  
  const [reviewers, setReviewers] = useState([]);
  const nextReviewerNumber = reviewerNumber + 1;
  const defaultNextReviewer = reviewers.find(r => r.reviewerNumber === nextReviewerNumber);
  const [submitterReviewerNumber, setSubmitterReviewerNumber] = useState(null);


  const [requisition, setRequisition] = useState(null);
  const [isRowAdded, setIsRowAdded] = useState(false); 
  const [comments, setComments] = useState({});
  const [status, setStatus] = useState('Submitted'); 
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 

  const submitterRevNumFromForm = formData.submitterReviewerNumber;
  const isReviewedStatus        = formData.status?.startsWith("Reviewed");
  const isNotSubmitter          = theUserId !== formData.userId;
  
  const [isConfirmed, setisConfirmed] = useState(false);
  


  const districtOptions = districts.map((district) => ({
    value: district,
    label: district
  }));

  const [districtAndAreaProgramPairs, setDistrictAndAreaProgramPairs] = useState([]);


  const [costItems, setCostItems] = useState([
    { costDriver: '', isCustom: false, customCostDriver: '', justification: '', quantity: '', unitPrice: '', total: '', supportDocuments: '', quantityTotal: '', unitPriceTotal: '', totalTotal: '' }
  ]);

  const [hasChanges, setHasChanges] = useState(false);


     const [quantityTotal, setQuantityTotal] = useState(0);
     const [unitPriceTotal, setUnitPriceTotal] = useState(0);
     const [totalTotal, setTotalTotal] = useState(0); 

     const reviewerSubmitterNumber = formData.submitterReviewerNumber;

     useEffect(() => {
      async function loadEligible() {
        try {
          const token = localStorage.getItem("token");
          const { data } = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/users/reviewers-for-disbursement`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const list = Array.isArray(data) ? data : [];
          console.log("Eligible reviewers:", list);
          setEligibleReviewers(list);
        } catch (err) {
          console.error("Failed to fetch eligible reviewers:", err);
          setEligibleReviewers([]);
        }
      }
      loadEligible();
    }, []);
         
     const canApprove =
  isReviewedStatus &&
  reviewerNumber === formData.currentReviewerNumber &&
  theUserId !== formData.userId &&
  (
    submitterRevNumFromForm == null
      ? reviewerNumber === 2 || reviewerNumber === 3
      : 
        true
  );
 
            
    

     useEffect(() => {
      const fetchCostDrivers = async () => {
        try {
          const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/CostDriverOptions`);
          const list = Array.isArray(data) ? data : [];
          setCostDriverOptions(list);
        } catch (err) {
          console.error("Failed to load cost-driver options", err);
          setCostDriverOptions([]);
        }
      };
      fetchCostDrivers();
    }, []);
    
    const currentUser = React.useMemo(() => {
      if (!token) return { id: null, reviewerNumber: null };
    
      try {
        const decoded = jwtDecode(token);
        const userId = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] || null;
        return {
          id: userId,
          reviewerNumber: null
        };
      } catch {
        return { id: null, reviewerNumber: null };
      }
    }, [token]);
    
    
  useEffect(() => {
    setIsClaimedByMe(false);
  }, [formData.currentReviewerNumber]);

  useEffect(() => {
    // If I am the current reviewer, I have claimed it
    if (reviewerNumber === formData.currentReviewerNumber) {
      setIsClaimedByMe(true);
    }
  }, [reviewerNumber, formData.currentReviewerNumber]);

  useEffect(() => {
    const fetchMyReviewerNumber = async () => {
      if (!theUserId) return;
      try {
        const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
        const reviewersList = Array.isArray(resp.data) ? resp.data : [];
        setReviewers(reviewersList);
  
        const me = reviewersList.find(r => String(r.id).toLowerCase() === theUserId.toLowerCase());
        if (me) {
          setReviewerNumber(me.reviewerNumber);
        }
      } catch (err) {
        console.error("Failed loading reviewers:", err);
        setReviewers([]);
      }
    };
  
    fetchMyReviewerNumber();
  }, [theUserId]);
  
    const handleCheckedRequisitionModalClose = () => {
      navigate('/staff-requisitions');
    };
    const handleReviewedRequisitionModalClose = () => {
      navigate('/notifications');
    };
  
    const handleErrorModalClose = () => {
      console.log("Closed Error modal");
      setShowErrorModal(false);
    };
    const handleApprovedModalClose = () => {
      navigate('/notifications');
    };
    const handleNoInternetModalClose = () => {
      console.log("Closed No Internet modal");
      setShowNoInternetModal(false);
    };

    useEffect(() => {
      const fetchReviewers = async () => {
        try {
          const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
          const allReviewers = Array.isArray(data)
            ? data.map(r => ({
                ...r,
                id: String(r.id),
                reviewerNumber: r.reviewerNumber
              }))
            : [];
    
          setReviewers(allReviewers);
    
          if (!submitterReviewerNumber) return;
    
          const filteredReviewers = allReviewers.filter(
            r => r.reviewerNumber !== submitterReviewerNumber
          );
    
          const nextReviewer = filteredReviewers.find(
            r => r.reviewerNumber > submitterReviewerNumber
          );
    
          if (nextReviewer) {
            setFormData(prev => ({
              ...prev,
              nextReviewerId: nextReviewer.id
            }));
          }
        } catch (error) {
          console.error("Error fetching reviewers:", error);
          setReviewers([]);
        }
      };
    
      fetchReviewers();
    }, [submitterReviewerNumber]);
      
  // Replace the entire current useEffect with this:
  useEffect(() => {
    fetchRequisitionDetails();
  }, [requisitionID]);
  

    useEffect(() => {

      const newQuantityTotal = costItems.reduce((acc, item) => acc + Number(item.quantity || 0), 0);
      const newUnitPriceTotal = costItems.reduce((acc, item) => acc + Number(item.unitPrice || 0), 0);
      const newTotalTotal = costItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.unitPrice || 0)), 0);
    
      setQuantityTotal(newQuantityTotal);
      setUnitPriceTotal(newUnitPriceTotal);
      setTotalTotal(newTotalTotal);
    }, [costItems]); 

    useEffect(() => {
    // Check if requisition status is Approved or Disbursed
    const isEligibleStatus = formData.status === "Approved" || formData.status === "Disbursed";
    
    setShowSurrenderCheckbox(isSurrenderReviewer && isEligibleStatus);
  }, [isSurrenderReviewer, formData.status]);  // Add isSurrenderReviewer here


  const currentReviewer = reviewers.find(
    r => r.reviewerNumber === formData.currentReviewerNumber
  );


  // Debug useEffect for form data changes
  useEffect(() => {
      console.log("=== FORM DATA UPDATED ===");
      console.log("claimedBySurrenderReviewerId:", formData.claimedBySurrenderReviewerId);
      console.log("status:", formData.status);
      console.log("currentReviewerNumber:", formData.currentReviewerNumber);
      console.log("nextReviewerId:", formData.nextReviewerId);
  }, [formData.claimedBySurrenderReviewerId, formData.status, formData.currentReviewerNumber, formData.nextReviewerId]);

  // Debug useEffect for claim status changes
  useEffect(() => {
      console.log("=== CLAIM STATUS UPDATED ===");
      console.log("claimStatus:", claimStatus);
  }, [claimStatus]);
    const getSupportDocuments = (driverName) => {
      const match = costDriverOptions.find(opt => opt.costDriver === driverName);
      return match?.supportDocuments || "Receipt(s)";
    };

    useEffect(() => {
      const newBlastingTotal = blastingCostItems.reduce((acc, item) => acc + (Number(item.total) || 0), 0);
      setBlastingTotalTotal(newBlastingTotal);
    }, [blastingCostItems]);

  const getDefaultUnitPrice = (driverName) => {
    const match = costDriverOptions.find(opt => opt.costDriver === driverName);
    const price = match?.defaultUnitPrice;
    return price > 0 ? price.toString() : "";
  };

const handleModalClose = () => {
        
        navigate('/staff-requisitions');
      };



  
  const addRow = () => {
    const newRow = {
      costDriver: '',
      isCustom: false,
      customCostDriver: '',
      justification: '',
      quantity: '',
      unitPrice: '',
      total: '',
      supportDocuments: ''
    };

    setCostItems([...costItems, newRow]);
    setIsRowAdded(true);
  };
  
  
  
  const removeRow = (index) => {
    const updatedCostItems = costItems.filter((_, i) => i !== index);
    setCostItems(updatedCostItems);
    if (updatedCostItems.length === 1) {
      setIsRowAdded(false); 
    }
  };

  

        
  function formatDateForInput(dateString) {
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split('T')[0];
}

const formatDate = iso => {
  if (!iso) return 'N/A';
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", {
    day:   "2-digit",
    month: "short",
    year:  "numeric"
  });
};

const handlePrint = () => {
  setIsPreparingPrint(true);
  
  const content = document.getElementById('printable-area');
  if (!content) {
      console.error('Print target not found: printable-area');
      setIsPreparingPrint(false);
      return;
  }

  // Use the actual requisition data from state
  const requisitionID = requisition?.requisitionID || 'Draft';
  const requisitionDate = requisition?.requisitionDate ? formatDate(requisition.requisitionDate) : new Date().toLocaleDateString();
  const status = requisition?.status || 'Draft';
  const staffName = requisition?.staffName || '';

  // Get cost drivers from state
  const blastingCostDrivers = requisition?.blastingCostDrivers?.map(driver => ({
      costDriver: driver.costDriver || driver.customCostDriver || '',
      justification: driver.justification || '',
      quantity: driver.quantity || '0',
      unitPrice: driver.unitPrice || '0',
      total: driver.total || '0',
      supportDocuments: driver.supportDocuments || ''
  })) || [];

  const otherCostDrivers = requisition?.costDrivers?.map(driver => ({
      costDriver: driver.costDriver || driver.customCostDriver || '',
      justification: driver.justification || '',
      quantity: driver.quantity || '0',
      unitPrice: driver.unitPrice || '0',
      total: driver.total || '0',
      supportDocuments: driver.supportDocuments || ''
  })) || [];

  // Get district pairs
  const districtPairs = requisition?.districtAndAreaProgramPairs?.map(pair => ({
      district: pair.district || '',
      areaProgram: pair.areaProgram || ''
  })) || [];

  // Get signature
  const signatureImageUrl = submitterSignaturePath 
      ? `${staticBaseUrl}/${submitterSignaturePath}`
      : null;
      
  // Calculate totals
  const blastingTotal = blastingCostDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0);
  const otherTotal = otherCostDrivers.reduce((sum, driver) => sum + (parseFloat(driver.total) || 0), 0);
  const grandTotal = blastingTotal + otherTotal;

  const printWindow = window.open('', '_blank', 'width=1000,height=800');
  
  printWindow.document.write(`
      <html>
      <head>
          <title>Requisition Form - ${requisitionID}</title>
          <style>
              @page {
                  margin: 0;
                  size: auto;
              }
              @page :header { display: none !important; }
              @page :footer { display: none !important; }
              * {
                  margin: 0;
                  padding: 0;
                  box-sizing: border-box;
              }
              body {
                  font-family: 'Arial', sans-serif;
                  font-size: 12px;
                  line-height: 1.4;
                  color: #000;
                  padding: 20px 25px;
                  background: white;
              }
              .print-header {
                  text-align: center;
                  margin-bottom: 2px;
                  padding-bottom: 2px;
                  border-bottom: 2px solid #333;
              }
              .print-header h1 {
                  font-size: 22px;
                  margin-bottom: 2px;
                  color: #2c3e50;
                  text-transform: uppercase;
                  letter-spacing: 1px;
              }
              .print-meta {
                  display: flex;
                  justify-content: space-between;
                  font-size: 12px;
                  margin-bottom: 2px;
                  flex-wrap: wrap;
                  gap: 15px;
              }
              .meta-item {
                  display: flex;
                  flex-direction: column;
              }
              .meta-label {
                  font-weight: bold;
                  color: #555;
                  margin-bottom: 0px;
              }
              .info-columns {
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 20px;
                  margin-bottom: 3px;
              }
              .info-column {
                  background: #f8f9fa;
                  padding: 18px;
                  border-radius: 6px;
                  border: 1px solid #e9ecef;
                  height: fit-content;
              }
              .info-column h4 {
                  margin-bottom: 5px;
                  color: #495057;
                  border-bottom: 2px solid #007bff;
                  padding-bottom: 8px;
                  font-size: 14px;
                  text-transform: uppercase;
                  font-weight: bold;
              }
              .form-field {
                  margin-bottom: 2px;
              }
              .form-field label {
                  display: block;
                  font-weight: bold;
                  font-size: 11px;
                  margin-bottom: 4px;
                  color: #555;
                  text-transform: uppercase;
              }
              .form-field .field-value {
                  padding: 8px 10px;
                  border: 1px solid #ddd;
                  border-radius: 4px;
                  background: white;
                  min-height: 35px;
                  display: flex;
                  align-items: center;
                  word-break: break-word;
                  font-size: 11px;
              }
              .empty-field {
                  color: #999;
                  font-style: italic;
              }
              .print-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin: 10px 0;
                  font-size: 10px;
                  page-break-inside: avoid;
              }
              .print-table th {
                  background-color: #2c3e50;
                  color: black;
                  padding: 5px 6px;
                  text-align: left;
                  font-weight: bold;
                  border: 1px solid #444;
                  font-size: 11px;
                  text-transform: uppercase;
              }
              .print-table td {
                  padding: 4px 6px;
                  border: 1px solid #ddd;
                  vertical-align: top;
              }
              .print-table tfoot td {
                  background-color: #e9ecef;
                  font-weight: bold;
                  border-top: 2px solid #333;
                  font-size: 11px;
              }
              .cost-driver-table {
                  font-size: 9px;
              }
              .cost-driver-table td {
                  max-width: 180px;
                  overflow-wrap: break-word;
              }
              .cost-driver-table .justification-cell {
                  max-width: 250px;
              }
              .section-heading {
                  font-size: 14px;
                  font-weight: bold;
                  margin: 12px 0 6px 0;
                  color: #2c3e50;
                  border-bottom: 1px solid #ddd;
                  padding-bottom: 5px;
              }
              .signature-section {
                  margin-top: 0;
                  padding-top: 0;
                  text-align: center;
                  width: 100%;
              }
              .signature-container {
                  display: inline-block;
                  text-align: center;
                  margin: 0 auto;
                  padding: 2px 20px;
              }
              .signed-by-label {
                  font-size: 11px;
                  margin-bottom: 2px;
                  color: #666;
                  text-transform: none !important;
              }
              .signature-image {
                  max-width: 120px !important;
                  max-height: 40px !important;
                  border-bottom: 1px solid #000;
                  margin: 0 auto 1px auto;
                  display: block;
              }
              .user-full-name {
                  font-weight: bold;
                  margin-top: 3px;
                  font-size: 11px;
                  text-transform: none !important;
              }
              .grand-total-print {
                  text-align: right;
                  font-weight: bold;
                  font-size: 14px;
                  margin-top: 15px;
                  padding: 10px;
                  background-color: #f8f9fa;
                  border: 1px solid #ddd;
                  border-radius: 4px;
              }
          </style>
      </head>
      <body>
          <div class="print-header">
              <h1>REQUISITION FORM</h1>
              <div class="print-meta">
                  <div class="meta-item">
                      <span class="meta-label">Requisition ID:</span>
                      <span>${requisitionID}</span>
                  </div>
                  <div class="meta-item">
                      <span class="meta-label">Requisition Date:</span>
                      <span>${requisitionDate}</span>
                  </div>
                  <div class="meta-item">
                      <span class="meta-label">Status:</span>
                      <span>${status}</span>
                  </div>
              </div>
          </div>

          <div class="info-columns">
              <!-- Staff Information Column -->
              <div class="info-column">
                  <h4>Staff Details</h4>
                  <div class="form-field">
                      <label>Staff Name:</label>
                      <div class="field-value">${requisition?.staffName || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Staff Level:</label>
                      <div class="field-value">${requisition?.staffLevel || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Supervisor Name:</label>
                      <div class="field-value">${requisition?.supervisorName || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
              </div>
              
              <!-- Activity Information Column -->
              <div class="info-column">
                  <h4>Activity Details</h4>
                  <div class="form-field">
                      <label>Activity Duration:</label>
                      <div class="field-value" style="padding: 4px 6px;">
                          ${requisition?.from ? formatDate(requisition.from) : 'Not provided'} 
                          &nbsp;to&nbsp; 
                          ${requisition?.to ? formatDate(requisition.to) : 'Not provided'}
                      </div>
                  </div>
                  <div class="form-field">
                      <label>Activity Name:</label>
                      <div class="field-value">${requisition?.activityName || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Activity Purpose:</label>
                      <div class="field-value">${requisition?.activityPurpose || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Target Client:</label>
                      <div class="field-value">${requisition?.targetClient || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Expected Impact:</label>
                      <div class="field-value">${requisition?.expectedImpact || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  
                  <!-- DISTRICT & AREA PROGRAM PAIRS -->
                  <div class="form-field">
                      <label>District & Area Program:</label>
                      <div class="field-value" style="padding: 10px; background: #f8f9fa; border-radius: 4px;">
                          ${districtPairs.length > 0 ? `
                          <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                              <thead>
                                  <tr>
                                      <th style="text-align: left; padding: 4px;">#</th>
                                      <th style="text-align: left; padding: 4px;">District</th>
                                      <th style="text-align: left; padding: 4px;">Area Program</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  ${districtPairs.map((pair, index) => `
                                      <tr>
                                          <td style="padding: 4px; border-bottom: 1px solid #eee;">${index + 1}</td>
                                          <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.district || 'Not specified'}</td>
                                          <td style="padding: 4px; border-bottom: 1px solid #eee;">${pair.areaProgram || 'Not specified'}</td>
                                      </tr>
                                  `).join('')}
                              </tbody>
                          </table>
                      ` : '<span class="empty-field">Not provided</span>'}
                      </div>
                  </div>
              </div>
              
              <!-- Project Information Column -->
              <div class="info-column">
                  <h4>Project Details</h4>
                  <div class="form-field">
                      <label>Project Code:</label>
                      <div class="field-value">${requisition?.projectCode || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Project Name:</label>
                      <div class="field-value">${requisition?.projectName || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Budget Line Code:</label>
                      <div class="field-value">${requisition?.budgetLineCode || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Pay Mode:</label>
                      <div class="field-value">${requisition?.payMode || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Bank Name:</label>
                      <div class="field-value">${requisition?.bankName || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Branch:</label>
                      <div class="field-value">${requisition?.branch || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
                  <div class="form-field">
                      <label>Account Number:</label>
                      <div class="field-value">${requisition?.accountNumber || '<span class="empty-field">Not provided</span>'}</div>
                  </div>
              </div>
          </div>

          <!-- Blasting Cost Drivers Section -->
          <div class="section-heading">BLASTING COST DRIVERS</div>                
          ${blastingCostDrivers.length > 0 ? `
              <table class="print-table cost-driver-table">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Cost Driver</th>
                          <th>Justification</th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th>Total</th>
                          <th>Support Documents</th>
                      </tr>
                  </thead>
                  <tbody>
                      ${blastingCostDrivers.map((driver, index) => `
                          <tr>
                              <td>${index + 1}</td>
                              <td>${driver.costDriver || '<span class="empty-field">Not specified</span>'}</td>
                              <td class="justification-cell">${driver.justification || '<span class="empty-field">Not provided</span>'}</td>
                              <td>${driver.quantity || '0'}</td>
                              <td>${driver.unitPrice || '0'}</td>
                              <td>${driver.total || '0'}</td>
                              <td>${driver.supportDocuments || '<span class="empty-field">Not specified</span>'}</td>
                          </tr>
                      `).join('')}
                  </tbody>
                  <tfoot>
                      <tr>
                          <td colspan="5" style="text-align: right;"><strong>Blasting Total:</strong></td>
                          <td><strong>${blastingTotal.toLocaleString()}</strong></td>
                          <td></td>
                      </tr>
                  </tfoot>
              </table>
          ` : '<p class="empty-field">No blasting cost drivers</p>'}

          <!-- Other Cost Drivers Section -->
          <div class="section-heading">OTHER COST DRIVERS</div>                
          ${otherCostDrivers.length > 0 ? `
              <table class="print-table cost-driver-table">
                  <thead>
                      <tr>
                          <th>#</th>
                          <th>Cost Driver</th>
                          <th>Justification</th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th>Total</th>
                          <th>Support Documents</th>
                      </tr>
                  </thead>
                  <tbody>
                      ${otherCostDrivers.map((driver, index) => `
                          <tr>
                              <td>${index + 1}</td>
                              <td>${driver.costDriver || '<span class="empty-field">Not specified</span>'}</td>
                              <td class="justification-cell">${driver.justification || '<span class="empty-field">Not provided</span>'}</td>
                              <td>${driver.quantity || '0'}</td>
                              <td>${driver.unitPrice || '0'}</td>
                              <td>${driver.total || '0'}</td>
                              <td>${driver.supportDocuments || '<span class="empty-field">Not specified</span>'}</td>
                          </tr>
                      `).join('')}
                  </tbody>
                  <tfoot>
                      <tr>
                          <td colspan="5" style="text-align: right;"><strong>Other Cost Total:</strong></td>
                          <td><strong>${otherTotal.toLocaleString()}</strong></td>
                          <td></td>
                      </tr>
                  </tfoot>
              </table>
          ` : '<p class="empty-field">No other cost drivers</p>'}

          <!-- Grand Total -->
          ${(blastingCostDrivers.length > 0 || otherCostDrivers.length > 0) ? `
              <div class="grand-total-print">
                  Blasting Cost Drivers Total: ${blastingTotal.toLocaleString()} &nbsp;|&nbsp; Other Cost Drivers Total: ${otherTotal.toLocaleString()} &nbsp;|&nbsp; 
                  <strong>Grand Total: ${grandTotal.toLocaleString()}</strong>
              </div>
          ` : ''}

          <!-- Signature Section -->
          <div class="signature-section">
              <div class="signature-container">
                  <div class="signed-by-label">Signed by:</div>
                  ${signatureImageUrl ? `
                      <img src="${signatureImageUrl}" alt="Signature" class="signature-image" />
                  ` : `
                      <div style="height: 1px; border-bottom: 1px solid #000; margin: 0 auto 1px auto; width: 150px;"></div>
                  `}
                  <div class="user-full-name">${staffName}</div>
                  <div style="font-size: 10px; color: #666; margin-top: 1px;">${requisitionDate}</div>
              </div>
          </div>
      </body>
      </html>
  `);
  
  printWindow.document.close();
  
  setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      
      setTimeout(() => {
          printWindow.close();
          setIsPreparingPrint(false);
      }, 1000);
  }, 1000);
};

const addPair = () => {
  setFormData(fd => ({
    ...fd,
    districtAndAreaProgramPairs: [
      ...fd.districtAndAreaProgramPairs,
      { id: null, district: "", areaProgram: "" }
    ]
  }));
};

const removePair = idx => {
  setFormData(fd => ({
    ...fd,
    districtAndAreaProgramPairs: fd.districtAndAreaProgramPairs.filter((_, i) => i !== idx)
  }));
};

const updatePair = (idx, key, value) => {
  setFormData(fd => {
    const pairs = [...fd.districtAndAreaProgramPairs];
    pairs[idx] = { ...pairs[idx], [key]: value };
    return { ...fd, districtAndAreaProgramPairs: pairs };
  });
  

  const currentPairs = [...districtAndAreaProgramPairs];
  currentPairs[idx] = { ...currentPairs[idx], [key]: value };
  setDistrictAndAreaProgramPairs(currentPairs);
  setHasChanges(true);
};



  
const handleClaimReview = async () => {
    try {
        const token = localStorage.getItem("token");
        
        if (!token) {
            setToastMessage("You must be logged in to claim this review.");
            setToastType('error');
            setShowToast(true);
            setTimeout(() => setShowToast(false), 4000);
            return;
        }

        // Different logic based on whether someone has already claimed it
        if (claimStatus.claimedById && !claimStatus.isClaimedByMe) {
            // Taking from someone else (ANY user type)
            const response = await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/take-from-reviewer`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            
            // Update claim status
            setClaimStatus({
                isClaimedByMe: true,
                claimedById: currentUser.id,
                claimedByName: fullName,
                claimedByDate: new Date().toISOString()
            });
            
            setToastMessage("Requisition taken successfully. You can now review it.");
            setToastType('success');
            setShowToast(true);
            setTimeout(() => setShowToast(false), 5000);
        } else {
            // Claiming an unclaimed requisition
            if (isSurrenderReviewer) {
                // Surrender Reviewer claiming an unclaimed requisition
                const response = await axios.put(
                    `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/claim-by-surrender-reviewer`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                
                // Update claim status
                setClaimStatus({
                    isClaimedByMe: true,
                    claimedById: currentUser.id,
                    claimedByName: fullName,
                    claimedByDate: new Date().toISOString()
                });
                
                setToastMessage("You have taken this requisition successfully");
                setToastType('success');
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
            } else {
                // Regular Reviewer claiming an unclaimed requisition
                const dto = {
                    requisitionId: requisitionID,
                    userId: formData.userId,
                    requisitionDate: formData.requisitionDate,
                    staffName: formData.staffName,
                    staffLevel: formData.staffLevel,
                    supervisorName: formData.supervisorName,
                    userType: formData.userType,
                    from: formData.from,
                    to: formData.to,
                    activityName: formData.activityName,
                    activityPurpose: formData.activityPurpose,
                    targetClient: formData.targetClient,
                    expectedImpact: formData.expectedImpact,
                    country: formData.country,
                    hubOffice: formData.hubOffice,
                    projectCode: formData.projectCode,
                    budgetLineCode: formData.budgetLineCode,
                    projectName: formData.projectName,
                    payMode: formData.payMode,
                    bankName: formData.bankName,
                    branch: formData.branch,
                    accountNumber: formData.accountNumber,
                    phoneNumber: formData.phoneNumber,
                    status: formData.status,
                    nextReviewerId: theUserId,
                    costDrivers: formData.costDrivers.map(cd => ({
                        id: cd.id,
                        costDriver: cd.costDriver,
                        justification: cd.justification,
                        quantity: +cd.quantity,
                        unitPrice: +cd.unitPrice,
                        supportDocuments: cd.supportDocuments,
                        totalTotal: cd.total
                    })),
                    blastingCostDrivers: formData.blastingCostDrivers ? formData.blastingCostDrivers.map(bcd => ({
                        id: bcd.id,
                        costDriver: bcd.costDriver || '',
                        justification: bcd.justification || '',
                        quantity: Number(bcd.quantity) || 0,
                        unitPrice: Number(bcd.unitPrice) || 0,
                        supportDocuments: bcd.supportDocuments || '',
                        totalTotal: (Number(bcd.quantity) || 0) * (Number(bcd.unitPrice) || 0)
                    })) : [],
                    districtAndAreaProgramPairs: formData.districtAndAreaProgramPairs.map(p => ({
                        district: p.district,
                        areaProgram: p.areaProgram
                    })),
                    claimedBySurrenderReviewerId: claimStatus.claimedById ? null : formData.claimedBySurrenderReviewerId,
                    currentReviewerNumber: reviewerNumber
                };

                await axios.patch(
                    `${process.env.REACT_APP_API_BASE_URL}/requisition/update`,
                    dto,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                setFormData(f => ({
                    ...f,
                    currentReviewerNumber: reviewerNumber,
                    claimedBySurrenderReviewerId: claimStatus.claimedById ? null : f.claimedBySurrenderReviewerId
                }));
                
                // Update claim status
                setClaimStatus({
                    isClaimedByMe: true,
                    claimedById: currentUser.id,
                    claimedByName: fullName,
                    claimedByDate: new Date().toISOString()
                });
                
                setIsClaimedByMe(true);
                setToastMessage("You have taken this requisition successfully");
                setToastType('success');
                setShowToast(true);
                setTimeout(() => setShowToast(false), 6000);
            }
        }
        
        // Refresh data
        await fetchRequisitionDetails();

    } catch (err) {
        console.error("Failed to claim review", err);
        setToastMessage("Could not take this requisition. Please try again later");
        setToastType('error');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 6000);
    }
};



          
          
          
  const handleInputChange = (index, field, value) => {
            const updatedItems = [...costItems];
            updatedItems[index][field] = value;
          
            if (field === 'costDriver') {
              if (!updatedItems[index].isCustom) {
                const supportDoc = value === 'Other'
                  ? 'Type the support document'
                  : getSupportDocuments(value);
          
                updatedItems[index].supportDocuments = supportDoc;
              }
            }
          
            if (field === 'quantity' || field === 'unitPrice') {
              const quantity = field === 'quantity'
                ? Number(value) || 0
                : Number(updatedItems[index].quantity) || 0;
              const unitPrice = field === 'unitPrice'
                ? Number(value) || 0
                : Number(updatedItems[index].unitPrice) || 0;
              updatedItems[index].total = quantity * unitPrice;
            }
          
            setCostItems(updatedItems);
            setHasChanges(true);
          };                    
        
                          
        const formatCurrency = (value) => {
          if (value === null || value === undefined) {
            return 'MK 0';
          }
          const numValue = Number(value);
          if (isNaN(numValue)) {
            return 'MK 0';
          }
          return `MK ${numValue.toLocaleString('en-US')}`;
        };
          
          
        const formatQuantityTotal = (value) => {
          if (!value || value === 0) {
            return ''; 
          }
          return ` ${Number(value).toLocaleString('en-US')}`;
      };



    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
      setHasChanges(true);
    };

  if (!requisition) {
    return <div>Loading...</div>; 
  }


const handleCommentButtonClick = (fieldId) => {
  setComments((prevComments) => ({
    ...prevComments,
    [fieldId]: prevComments[fieldId]?.visible
      ? { ...prevComments[fieldId], visible: false }
      : { visible: true, text: prevComments[fieldId]?.text || '' }, 
  }));
};

const handleCommentChange = (fieldId, comment) => {
  setComments((prevComments) => ({
    ...prevComments,
    [fieldId]: {
      ...prevComments[fieldId],
      text: comment, 
    },
  }));
};



const handleApproveClick = async (event) => {
  event.preventDefault();

  if (!navigator.onLine) {
    setShowNoInternetModal(true);
    return;
  }

  if (!formData.nextReviewerId) {
    setShowNextReviewerBeforeApprovingModal(true);
    return;
  }

  setIsSubmitting(true);

  try {
    const updatedStatus = "Approved";
    const sendNotificationToNextReviewer = true;
    const nextReviewerId = formData.nextReviewerId;

    const payload = {
      requisitionId: requisitionID,
      userId: formData.userId,
      requisitionDate: formData.requisitionDate,
      staffName: formData.staffName,
      staffLevel: formData.staffLevel,
      supervisorName: formData.supervisorName,
      userType: formData.userType,
      from: formData.from,
      to: formData.to,
      activityName: formData.activityName,
      activityPurpose: formData.activityPurpose,
      targetClient: formData.targetClient,
      expectedImpact: formData.expectedImpact,
      country: formData.country,
      hubOffice: formData.hubOffice,
      projectCode: formData.projectCode,
      budgetLineCode: formData.budgetLineCode,
      projectName: formData.projectName,
      payMode: formData.payMode,
      bankName: formData.bankName,
      branch: formData.branch,
      accountNumber: formData.accountNumber,
      phoneNumber: formData.phoneNumber,
      status: updatedStatus,
      costDrivers: costItems.map(item => ({
        id: item.id,
        costDriver: item.costDriver,
        justification: item.justification,
        quantity: parseFloat(item.quantity) || 0,
        unitPrice: parseFloat(item.unitPrice) || 0,
        supportDocuments: item.supportDocuments || '',
        totalTotal: item.totalTotal || 0
      })),
      blastingCostDrivers: blastingCostItems.map(item => ({
        id: item.id,
        costDriver: item.costDriver || '',
        justification: item.justification || '',
        quantity: Number(item.quantity) || 0,
        unitPrice: Number(item.unitPrice) || 0,
        supportDocuments: item.supportDocuments || '',
        totalTotal: (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0)
      })),
      districtAndAreaProgramPairs: districtAndAreaProgramPairs.map(pair => ({
        district: pair.district,
        areaProgram: pair.areaProgram
      })),
      nextReviewerId: nextReviewerId
    };
    await axios.patch(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/update`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
          "Content-Type": "application/json",
        }
      }
    );

    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/status`,
      {
        Status: "Approved",
        reviewersId: currentUser.id,
        currentReviewerId: currentUser.id, 
        nextReviewerId: formData.nextReviewerId,
        sendNotificationToNextReviewer: true,
        requesterID: formData.userId,
        requesterName: formData.staffName
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    
    setStatus(updatedStatus);
    setShowApprovedModal(true);
  } catch (error) {
    console.error("Error during approval:", error);
    setShowErrorModal(true);
    if (error.response) {
      console.error("Error response data:", error.response.data);
    } else {
      console.error("There was an error connecting to the server.");
    }
  } finally {
    setIsSubmitting(false);
  }
};


const handleNextReviewerClick = async (event) => {
  try {
    event.preventDefault();

    // ========== DEBUG LOGS START ==========
    console.log("=== START handleNextReviewerClick ===");
    console.log("formData.nextReviewerId:", formData.nextReviewerId);
    console.log("selectedSurrenderReviewer:", selectedSurrenderReviewer);
    console.log("reviewerNumber:", reviewerNumber);
    console.log("theUserId:", theUserId);
    console.log("formData.currentReviewerNumber:", formData.currentReviewerNumber);
    console.log("fullName:", fullName);
    // ========== DEBUG LOGS END ==========

    if (!navigator.onLine) {
      setShowNoInternetModal(true);
      return;
    }

    if (!formData.nextReviewerId) {
      console.log("No nextReviewerId found, showing modal");
      setShowselectNextReviewerModal(true);
      return;
    }

    // ========== ADDITIONAL DEBUG ==========
    console.log("=== VALIDATION PASSED ===");
    console.log("formData.nextReviewerId type:", typeof formData.nextReviewerId);
    console.log("formData.nextReviewerId value:", formData.nextReviewerId);
    console.log("Selected user from reviewers:", reviewers.find(r => r.id === formData.nextReviewerId));
    console.log("Full formData:", formData);
    // ========== DEBUG LOGS END ==========

    setIsSubmitting(true);
    
    try {
      const updatedStatus = `Reviewed by ${fullName}`;
      const sendNotificationToNextReviewer = true;
      const nextReviewerId = formData.nextReviewerId;

      console.log("District & Area Program Pairs:", districtAndAreaProgramPairs);

      const payload = {
        requisitionId: requisitionID,
        userId: formData.userId,
        requisitionDate: formData.requisitionDate,
        staffName: formData.staffName,
        staffLevel: formData.staffLevel,
        supervisorName: formData.supervisorName,
        userType: formData.userType,
        from: formData.from,
        to: formData.to,
        activityName: formData.activityName,
        activityPurpose: formData.activityPurpose,
        targetClient: formData.targetClient,
        expectedImpact: formData.expectedImpact,
        country: formData.country,
        hubOffice: formData.hubOffice,
        projectCode: formData.projectCode,
        budgetLineCode: formData.budgetLineCode,
        projectName: formData.projectName,
        payMode: formData.payMode,
        bankName: formData.bankName,
        branch: formData.branch,
        accountNumber: formData.accountNumber,
        phoneNumber: formData.phoneNumber,
        status: `Reviewed by ${fullName}`,
        costDrivers: costItems.map(item => ({
          id: item.id,
          costDriver: item.costDriver,
          justification: item.justification,
          quantity: parseFloat(item.quantity) || 0,
          unitPrice: parseFloat(item.unitPrice) || 0,
          supportDocuments: item.supportDocuments || '',
          totalTotal: item.totalTotal || 0
        })),
        blastingCostDrivers: blastingCostItems.map(item => ({
          id: item.id,
          costDriver: item.costDriver || '',
          justification: item.justification || '',
          quantity: Number(item.quantity) || 0,
          unitPrice: Number(item.unitPrice) || 0,
          supportDocuments: item.supportDocuments || '',
          totalTotal: (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0)
        })),
        districtAndAreaProgramPairs: districtAndAreaProgramPairs.map(pair => ({
          district: pair.district,
          areaProgram: pair.areaProgram 
        })),
        nextReviewerId: formData.nextReviewerId
      };
      console.log("Sending requisition update payload:", payload);

      const token = localStorage.getItem('token');
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}/requisition/update`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      );

      console.log("Update success:", response.data);

      // Find the next reviewer
      const nextReviewer = reviewers.find(r => r.id === formData.nextReviewerId);
      console.log("Next reviewer found:", nextReviewer);

      if (!nextReviewer) {
        console.error('Selected next reviewer not found in reviewers list');
        console.error("nextReviewerId:", formData.nextReviewerId);
        console.error("Reviewers:", reviewers);
        setShowErrorModal(true);
        setIsSubmitting(false);
        return;
      }

      // For current reviewer, check if user exists in reviewers list
      let currentReviewerNumber;
      let currentReviewerName = fullName;

      const currentReviewer = reviewers.find(r => r.id === theUserId);

      if (!currentReviewer) {
        // Current user is not in reviewers list (e.g., Surrender Reviewer)
        console.log('Current user not in reviewers list (likely Surrender Reviewer) - proceeding without reviewer number');
        currentReviewerNumber = -1;
      } else {
        currentReviewerNumber = currentReviewer.reviewerNumber;
        currentReviewerName = `${currentReviewer.firstName} ${currentReviewer.lastName}`;
      }

      const nextReviewerNumber = nextReviewer.reviewerNumber;

      console.log("Current reviewer number:", currentReviewerNumber);
      console.log("Next reviewer number:", nextReviewerNumber);

      // Prepare the status update payload
      const statusPayload = {
        Status: `Reviewed by ${fullName}`,
        reviewersId: theUserId,
        currentReviewerId: theUserId,
        nextReviewerId: formData.nextReviewerId,
        currentReviewerNumber: currentReviewerNumber,
        nextReviewerNumber: nextReviewerNumber,
        reviewersUserId: theUserId,
        currentReviewerUserId: theUserId,
        nextReviewerUserId: formData.nextReviewerId,
        sendNotificationToNextReviewer: sendNotificationToNextReviewer,
        requesterID: formData.userId,
        requesterName: formData.staffName
      };

      console.log("=== STATUS UPDATE PAYLOAD ===");
      console.log("Full payload:", statusPayload);
      console.log("Payload JSON string:", JSON.stringify(statusPayload, null, 2));

      // Send the status update
      try {
        const statusResponse = await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisitionID}/status`,
          statusPayload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        console.log("Status update response:", statusResponse.data);
      } catch (statusError) {
        console.error("Status update failed with error:", statusError.response?.data);
        console.error("Full error details:", statusError.response?.data?.errors);
        throw statusError;
      }      
      
      console.log("Status update successful");

      if (reviewerNumber === 1) {
        setShowCheckedRequisitionModal(true);
      } else if (reviewerNumber === 2) {
        setShowReviewedRequisitionModal(true);
      } else if (reviewerNumber === 3) {
        setShowApprovedModal(true);
      }
      
      setStatus(updatedStatus);
      setShowSuccessMessage(true);
      setShowModal(true);
    } catch (error) {
      console.error('handleNextReviewerClick Error Message: Error updating requisition:', error);
      if (error.response) {
        console.error('handleNextReviewerClick Error Message: Error response:', error.response.data);
        console.error('Status code:', error.response.status);
        setShowErrorModal(true);
      } else if (error.request) {
        console.error('handleNextReviewerClick Error Message: No response received:', error.request);
        setShowErrorModal(true);
      } else {
        console.error('handleNextReviewerClick Error Message: Error Message:', error.message);
        setShowErrorModal(true);
      }
    }
  } catch (error) {
    console.error('Outer catch block error:', error);
    setShowErrorModal(true);
  } finally {
    setIsSubmitting(false);
  }
};

const testSurrenderEndpoint = async () => {
  try {
    const token = localStorage.getItem("token");
    console.log("Testing endpoint with token:", token ? "Exists" : "Missing");
    console.log("Requisition ID:", requisitionID);

    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/test-surrender`,
      {}, // Empty body since your test endpoint doesn't need one
      { 
        headers: { 
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        } 
      }
    );

    console.log("Test successful:", response.data);
    setToastMessage(`Test successful! User ID: ${response.data.userId}, Requisition ID: ${response.data.requisitionId}`);
    setToastType('success');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
    
  } catch (err) {
    console.error("Test failed:", err);
    console.error("Error status:", err.response?.status);
    console.error("Error data:", err.response?.data);
    
    if (err.response?.status === 401) {
      setToastMessage("Authentication failed - check your token");
    } else {
      setToastMessage(`Test failed: ${err.response?.data?.error || err.message}`);
    }
    setToastType('error');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
  }
};


const handleSurrenderNextReviewer = async () => {
  if (!selectedSurrenderReviewer) {
    setToastMessage("Please select a reviewer first");
    setToastType('error');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
    return;
  }

  console.log("Selected surrender reviewer ID:", selectedSurrenderReviewer);
  console.log("Current user ID:", theUserId);

  if (selectedSurrenderReviewer === theUserId) {
    setToastMessage("You cannot send the requisition to yourself. Please select a different reviewer.");
    setToastType('error');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
    return;
  }
  
  setIsSubmitting(true);
  try {
    const token = localStorage.getItem("token");
    
    // First, save the blasting cost drivers
    const blastingCostDriversData = blastingCostItems.map(item => ({
      id: item.id,
      costDriver: item.costDriver || '',
      justification: item.justification || '',
      quantity: Number(item.quantity) || 0,
      unitPrice: Number(item.unitPrice) || 0,
      supportDocuments: item.supportDocuments || '',
      totalTotal: (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0)
    }));

    console.log("Saving blasting cost drivers:", blastingCostDriversData);
    
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/blasting-cost-drivers`,
      { blastingCostDrivers: blastingCostDriversData },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    
    console.log("Sending to backend with NextReviewerId:", selectedSurrenderReviewer);
    
    const response = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/surrender-forward`,
      { NextReviewerId: selectedSurrenderReviewer },
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
    );

    console.log("Backend response:", response.data);
    
    // Get the next reviewer's info
    const nextReviewer = reviewers.find(r => r.id === selectedSurrenderReviewer);
    const nextReviewerName = nextReviewer ? 
      `${nextReviewer.firstName} ${nextReviewer.lastName}` : 
      response.data.nextReviewerName;
    
    // Wait a moment for backend to fully process
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // FORCE a complete refresh by fetching requisition details FIRST
    await fetchRequisitionDetails();
    
    // THEN explicitly check claim status again
    try {
      const claimResponse = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/is-claimed-by-me`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      console.log("Fresh claim status after forward:", claimResponse.data);
      
      // Update claim status only – formData is already refreshed by fetchRequisitionDetails
      setClaimStatus({
        isClaimedByMe: claimResponse.data.isClaimedByMe || false,
        claimedById: claimResponse.data.claimedById || null,
        claimedByName: claimResponse.data.claimedByName || null,
        claimedByDate: claimResponse.data.claimedByDate || null
      });
      
    } catch (claimError) {
      console.error('Error checking claim status after forward:', claimError);
      setClaimStatus({
        isClaimedByMe: false,
        claimedById: null,
        claimedByName: null,
        claimedByDate: null
      });
    }
    
    // Reset UI states
    setIsSurrenderChecked(false);
    setSelectedSurrenderReviewer('');
    setShowSurrenderCheckbox(false);
    
    // Set for success modal
    setForwardedToReviewerName(nextReviewerName);
    setShowSurrenderForwardSuccess(true);
    
    // Show success toast
    setToastMessage(`Requisition forwarded successfully to ${nextReviewerName}`);
    setToastType('success');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
    
  } catch (err) {
    console.error("Error:", err.response?.data || err.message);
    setToastMessage(`${err.response?.data?.message || "Failed to forward requisition. Please try again."}`);
    setToastType('error');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
  } finally {
    setIsSubmitting(false);
  }
};

const handleDisburseClick = async () => {

  setIsSubmitting(true);
  try{

  
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/status`,
        {
          Status: "Disbursed",
          ReviewersId: currentUser.id,
          NextReviewerId: "",                    
          currentReviewerId: currentUser.id, 
          SendNotificationToNextReviewer: false,   
          RequesterID: formData.userId,
          RequesterName: formData.staffName
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      setFormData(f => ({ ...f, status: "Disbursed" }));
      setShowDisbursedModal(true);  
    } catch (err) {
      console.error("Error disbursing:", err);
      alert("Failed to mark as Disbursed. Try again.");
    } 
  }finally {
    setIsSubmitting(false);
  }
};


const handleCheckboxChange = () => {
  setisConfirmed((prev) => !prev);
};

const handleDistrictChange = (index, selectedOption) => {
  const updatedPairs = [...districtAndAreaProgramPairs];
  updatedPairs[index].district = selectedOption ? selectedOption.value : '';
  setDistrictAndAreaProgramPairs(updatedPairs);
  
  
  setFormData(prev => ({
    ...prev,
    districtAndAreaProgramPairs: updatedPairs
  }));
  setHasChanges(true);
};

const handleAreaProgramChange = (index, value) => {
  const updatedPairs = [...districtAndAreaProgramPairs];
  updatedPairs[index].areaProgram = value;
  setDistrictAndAreaProgramPairs(updatedPairs);
  
  setFormData(prev => ({
    ...prev,
    districtAndAreaProgramPairs: updatedPairs
  }));
  setHasChanges(true);
};

const addDistrictAPPair = () => {
  const newPair = { id: null, district: "", areaProgram: "", requisitionID: requisitionID };
  
  setFormData(prev => ({
    ...prev,
    districtAndAreaProgramPairs: [...prev.districtAndAreaProgramPairs, newPair]
  }));
  setDistrictAndAreaProgramPairs(prev => [...prev, newPair]);
};

const removeDistrictAPPair = (index) => {
  setFormData(prev => ({
    ...prev,
    districtAndAreaProgramPairs: prev.districtAndAreaProgramPairs.filter((_, i) => i !== index)
  }));
  setDistrictAndAreaProgramPairs(prev => prev.filter((_, i) => i !== index));
};

const getStatusClass = (status) => {
  if (status === "Draft") return "status-draft"; 
  if (status === "Submitted") return "status-submitted";
  if (status === "Surrender Submitted") return "status-surrender-submitted";
  if (status.startsWith("Reviewed by")) return "status-reviewed";
  if (status === "Approved") return "status-approved";
  if (status === "Surrender Approved") return "status-surrender-approved";
  if (status === "Disapproved") return "status-disapproved"; 
  if (status === "Disbursed") return "status-disbursed"; 
  if (status === "To be disbursed") return "status-to-be-disbursed"; 

  
  return ""; 
};

const fetchHistory = async () => {
  try {
    const token = localStorage.getItem("token");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/history`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    const audits = Array.isArray(data.audits) ? data.audits : [];
    const reviews = Array.isArray(data.reviews) ? data.reviews : [];

    setHistory({ audits, reviews });

    const combined = reviews.map((r, i) => ({
      step: r.step,
      reviewer: r.by,
      reviewedAt: r.at,
      status: audits[i]?.newValue || ""
    }));

    setCombinedHistory(combined);
    setShowHistory(true);
  } catch (err) {
    console.error("Failed to load history", err);
  }
};

const handleConfirmForward = async () => {
  try {
    setIsSubmitting(true);
    
    // First, forward the requisition
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/forward`,
      { nextReviewerId: forwardTo },
      { headers: { Authorization: `Bearer ${token}` } }
    );
      // Then update the status to "To be disbursed"
    await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/status`,
      {
        Status: "To be disbursed",
        ReviewersId: currentUser.id,
        NextReviewerId: "",
        RequesterID: formData.userId,
        RequesterName: formData.staffName,
        SendNotificationToNextReviewer: false
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setForwardedToName(selectedUser.fullName);
    setShowForwardConfirm(false);
    setShowForwardSuccess(true);
    
    // Show success toast
    setToastMessage(`Requisition forwarded successfully to ${selectedUser.fullName}`);
    setToastType('success');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
    
  } catch (err) {
    console.error("Forward failed", err);
    // Show more specific error message
    if (err.response) {
      console.error("Error response:", err.response.data);
      setToastMessage(`Forward failed: ${err.response.data.message || 'Please try again.'}`);
    } else {
      setToastMessage("Could not forward. Please check your connection and try again.");
    }
    setToastType('error');
    setShowToast(true);
    setTimeout(() => setShowToast(false), 6000);
    setShowForwardConfirm(false);
  } finally {
    setIsSubmitting(false);
  }
};

const isOverlayVisible = () => {
  const isClaimedBySomeoneElse = claimStatus.claimedById && !claimStatus.isClaimedByMe;
  const amCurrentReviewer = formData.currentReviewerNumber === reviewerNumber;
  const amSenderSurrenderReviewer = isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId;
  const isWithMe = claimStatus.isClaimedByMe || (amCurrentReviewer && !claimStatus.claimedById) || amSenderSurrenderReviewer;
  
  return !isWithMe;
};

// Helper function to get blasting cost drivers data for saving
const getBlastingCostDriversData = () => {
  return blastingCostItems.map(item => ({
    id: item.id,
    costDriver: item.costDriver || '',
    justification: item.justification || '',
    quantity: Number(item.quantity) || 0,
    unitPrice: Number(item.unitPrice) || 0,
    total: (Number(item.quantity) || 0) * (Number(item.unitPrice) || 0),
    supportDocuments: item.supportDocuments || '',
    requisitionID: requisitionID
  }));
};


return (
<div id="wrapper">
    <LoadingOverlay isVisible={isSubmitting} />

     {/* Toast Notification */}
          {showToast && (
              <div className={`toast-notification ${toastType}`}>
                  <div className="toast-content">
                      <span className="toast-icon">
                          {toastType === 'success' ? '✅' : '❌'}
                      </span>
                      <span className="toast-message">{toastMessage}</span>
                  </div>
                  <button className="toast-close" onClick={() => setShowToast(false)}>×</button>
              </div>
          )}

          {/* Sidebar */}
     <Sidebar userType={theUserType} />     

{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">



    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle (Topbar) */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






    {/* Begin Page Content */}
<div className="container-fluid">
  {/* Buttons Container - Added Print and ExportExcel buttons */}
  <div className="buttons-container">
    {/* Custom Print Button */}
    <button 
      className={`the-print-button ${isPreparingPrint ? 'printing' : ''}`} 
      onClick={handlePrint}
      disabled={isPreparingPrint}
      style={{
        opacity: isPreparingPrint ? 0.7 : 1,
        cursor: isPreparingPrint ? 'not-allowed' : 'pointer'
      }}
    >
      <i className="fas fa-print"></i> 
      {"Print"}
    </button>
    
    <ExportExcelButton
      formArray={formArray}
      setFormArray={setFormArray}
      currentFormData={exportFormData}
      costItems={exportCostItems} 
      fileName={`Requisition-${requisitionID}.xlsx`}
    />
  </div>

  <button
    type="button"
    onClick={() => navigate(-1)}
    className="top-page-arrow"
  >
    <i className="fas fa-arrow-left back-button"></i>
  </button>


<div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>
  <div
    className={`review-form-wrapper
      ${!isEditable && claimStatus.claimedById && !claimStatus.isClaimedByMe ? "pending-shadow" : ""}`}
  >
    {/* DEBUG INFO - I will remove this after testing */}
    <div style={{ 
        padding: '10px', 
        margin: '10px 0', 
        fontSize: '12px',
        display: 'block' /* Change to 'block' to see debug info */
    }}>
        <h4></h4>
        <p></p>
        <br/><br/><br/><br/>
    </div>

    
{/* Overlays */}
{(() => {
        
    console.log("=== OVERLAY DEBUG ===");
    console.log("isSurrenderReviewer:", isSurrenderReviewer);
    console.log("formData.nextReviewerId:", formData.nextReviewerId);
    console.log("theUserId:", theUserId);
    console.log("claimStatus.isClaimedByMe:", claimStatus.isClaimedByMe);
    console.log("formData.claimedBySurrenderReviewerId:", formData.claimedBySurrenderReviewerId);
    console.log("amSenderSurrenderReviewer:", isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId);
        
    // Check if someone else has claimed it
    const isClaimedBySomeoneElse = claimStatus.claimedById && !claimStatus.isClaimedByMe;
    // Check if I'm the current reviewer in regular workflow
    const amCurrentReviewer = formData.currentReviewerNumber === reviewerNumber;

    // Check if I am the Surrender Reviewer who sent this (the requisition has a nextReviewerId that is NOT me, and I am a Surrender Reviewer)
    const amSenderSurrenderReviewer = isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId;

    // Check if requisition is with me (either claimed, or I'm current reviewer, or I'm the sender Surrender Reviewer)
    const isWithMe = claimStatus.isClaimedByMe || (amCurrentReviewer && !claimStatus.claimedById) || amSenderSurrenderReviewer;    
    
    console.log("isClaimedBySomeoneElse:", isClaimedBySomeoneElse);
    console.log("amCurrentReviewer:", amCurrentReviewer);
    console.log("isWithMe:", isWithMe);

    // CASE 1: Requisition is with me - NO OVERLAY
    if (isWithMe) {
        console.log("CASE 1: User has requisition - NO OVERLAY");
        return null;
    }

    // CASE 2: Someone else has claimed it
    if (isClaimedBySomeoneElse) {
        console.log("CASE 2: Someone else has claimed it - SHOW OVERLAY WITH BUTTON");
        const claimant = reviewers.find(r => r.id === claimStatus.claimedById);
        if (claimant) {
            const claimantName = claimant.fullName || `${claimant.firstName} ${claimant.lastName}`;
            const claimantType = claimant.userType === "Surrender Reviewer" ? "Surrender" : "";
            
            return (
                <div className="pending-overlay">
                    <p className='overlay-text'>
                        This requisition is with {" "}
                        <strong>{claimantName} {claimantType ? `(${claimantType})` : ""}</strong>
                    </p>
                    
                    <button className="btn-claim" onClick={handleClaimReview}>
                        <b>Click here </b> to take this requisition from this person
                    </button>
                </div>
            );
        }
    }
    
    // CASE 3: Check if this requisition is assigned to someone (has nextReviewerId)
// CASE 3: Check if this requisition is assigned to someone (has nextReviewerId)
if (formData.nextReviewerId) {
    console.log("CASE 3: Requisition has nextReviewerId =", formData.nextReviewerId);
    console.log("Am I the next reviewer?", formData.nextReviewerId === theUserId);
    console.log("Am I a Surrender Reviewer?", isSurrenderReviewer);
    
    // If I am the next reviewer (recipient) - NO OVERLAY
    if (formData.nextReviewerId === theUserId) {
        console.log("CASE 3a: I am the next reviewer (recipient) - NO OVERLAY");
        return null;
    }
    
    // If I am a Surrender Reviewer who sent this requisition - NO OVERLAY
    // Check if the requisition was previously claimed by me (the Surrender Reviewer)
    // and now has a nextReviewerId that is not me
    if (isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId) {
        console.log("CASE 3c: I am the Surrender Reviewer sender - NO OVERLAY");
        return null;
    }
    
    // If I am NOT the next reviewer (sender or others) - SHOW OVERLAY
    console.log("CASE 3b: I am NOT the next reviewer (sender or others) - SHOW OVERLAY");
    const nextReviewer = reviewers.find(r => r.id === formData.nextReviewerId);
    if (nextReviewer) {
        const nextReviewerName = nextReviewer.fullName || `${nextReviewer.firstName} ${nextReviewer.lastName}`;
        
        return (
            <div className="pending-overlay">
                <p className='overlay-text'>
                    This requisition is with {" "}
                    <strong>{nextReviewerName}</strong>
                </p>
                <button className="btn-claim" onClick={handleClaimReview}>
                    <b>Click here </b> to take this requisition from this person
                </button>
            </div>
        );
    }
}
    
    // CASE 4: No one has claimed it but I'm not the current reviewer
    if (!amCurrentReviewer && !claimStatus.claimedById && !formData.nextReviewerId) {
        console.log("CASE 4: No one has it but I'm not current reviewer - SHOW OVERLAY WITHOUT BUTTON");
        const currentReviewer = reviewers.find(r => r.reviewerNumber === formData.currentReviewerNumber);
        if (currentReviewer) {
            const reviewerName = currentReviewer.fullName || `${currentReviewer.firstName} ${currentReviewer.lastName}`;
            
            return (
                <div className="pending-overlay">
                    <p className='overlay-text'>
                        This requisition is with {" "}
                        <strong>{reviewerName}</strong>
                    </p>
                    <button className="btn-claim" onClick={handleClaimReview}>
                        <b>Click here </b> to take this requisition from this person
                    </button>
                </div>
            );
        }
    }
    
    console.log("No overlay needed - falling through all cases");
    return null;
})()}





{/* Show if it's available for surrender reviewers to claim 
{showClaimButton && isSurrenderReviewer && !claimStatus.claimedById && (
    <div className="pending-overlay">
        <p className='overlay-text'>
            This requisition is available for surrender review
        </p>
        <button className="btn-claim" onClick={handleClaimReview}>
            <b>Click here </b> to claim this requisition for review
        </button>
    </div>
)}
*/}

        <form>

      <div className={`view-requisition-container ${isEditable ? 'editable' : ''}`}>          
        <div className="view-requisition-header">
          
          <h1 className="h3">Review Requisition</h1> <br/>
         
          <div className="requisition-header-info">
            
          
      {(reviewerNumber === 1 || reviewerNumber === 2 || reviewerNumber === 3 ) && formData.status === "Approved" ? (
        !forwardedToName ? (
          (() => {
            // Check if overlay should be shown (hide button when overlay is visible)
            const isClaimedBySomeoneElse = claimStatus.claimedById && !claimStatus.isClaimedByMe;
            const amCurrentReviewer = formData.currentReviewerNumber === reviewerNumber;
            const amSenderSurrenderReviewer = isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId;
            const isWithMe = claimStatus.isClaimedByMe || (amCurrentReviewer && !claimStatus.claimedById) || amSenderSurrenderReviewer;
            
            // Only show the button if the requisition is with the current user
            if (!isWithMe) return null;
            
            return (
              <div>
                <div className="bank-details">
                  <div><strong>Bank Name:</strong> {formData.bankName}</div>
                  <div><strong>Bank Account Number:</strong> {formData.accountNumber}</div>
                  <div><strong>Amount:</strong> {formatCurrency(totalTotal)}</div>
                </div>

                <button
                  type="button"
                  className="btn btn-success ml-2"
                  id="disbursed-button"
                  onClick={handleDisburseClick}
                >
                  Funds Disbursed <i className="fas fa-dollar-sign ml-1"></i>
                </button>
              </div>
            );
          })()
        ) : (
          <div className="after-forward-text">
            This requisition has been forwarded to <strong>{forwardedToName}</strong>.
          </div>
        )
      ) : null}

      {formData.status === "To be disbursed" && (
        <div className="bank‐and‐disburse">
          <div className="bank-details">
            <div><strong>Bank Name:</strong> {formData.bankName}</div>
            <div><strong>Bank Account Number:</strong> {formData.accountNumber}</div>
            <div><strong>Amount:</strong> {formatCurrency(totalTotal)}</div>
          </div>

          <button
            type="button"
            className="btn btn-success ml-2"
            id="disbursed-button"
            onClick={handleDisburseClick}
            disabled={(() => {
              const isClaimedBySomeoneElse = claimStatus.claimedById && !claimStatus.isClaimedByMe;
              const amCurrentReviewer = formData.currentReviewerNumber === reviewerNumber;
              const amSenderSurrenderReviewer = isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId;
              const isWithMe = claimStatus.isClaimedByMe || (amCurrentReviewer && !claimStatus.claimedById) || amSenderSurrenderReviewer;
              return !isWithMe;
            })()}
            style={{
              opacity: (() => {
                const isClaimedBySomeoneElse = claimStatus.claimedById && !claimStatus.isClaimedByMe;
                const amCurrentReviewer = formData.currentReviewerNumber === reviewerNumber;
                const amSenderSurrenderReviewer = isSurrenderReviewer && formData.nextReviewerId && formData.nextReviewerId !== theUserId;
                const isWithMe = claimStatus.isClaimedByMe || (amCurrentReviewer && !claimStatus.claimedById) || amSenderSurrenderReviewer;
                return isWithMe ? 1 : 0.5;
              })()
            }}
          >
            Funds Disbursed <i className="fas fa-dollar-sign ml-1"></i>
          </button>
        </div>
      )}


      <div className="review-status-container">
          <div id="review-requisition-requisition-id">
            <b>Requisition ID:</b> {requisitionID}
          </div>
          <div className={`status-display ${isOverlayVisible() ? 'greyed-out' : ''}`}
            style={{ opacity: isOverlayVisible() ? '0.6' : '1' }}>
            <div><strong>Status:</strong></div>
            <div className={`badge ${getStatusClass(formData.status)} ${isOverlayVisible() ? 'greyed-out-badge' : ''}`}
              style={{ backgroundColor: isOverlayVisible() ? '#e9ecef' : '' }}>
              {formData.status}
            </div>

               {
                    /*
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={fetchHistory}
                    >
                      <FontAwesomeIcon icon={faHistory} /> View History
                    </button>  
                    */
                }  
          </div>
        </div>

        {/* Add the edited text display here */}
        {formData.surrenderEditText && (
          <div className="surrender-edit-text mt-2">
            <small className="text-muted">
              <i>{formData.surrenderEditText}</i>
            </small>
          </div>
        )}

        <br/><br/>
          </div>
        </div>
            
          
    
          <div className="requisition-details">

            <div className="view-requisition-date-and-id" id="status" hidden>
            <p><strong>Requisition Date:</strong> {new Date(requisition.requisitionDate).toLocaleDateString('en-GB', { 
                day: 'numeric', 
                month: 'long', 
                year: 'numeric' 
            })}</p>
            <p><strong>Requisition ID:</strong> {requisition.requisitionID}</p>
            </div>
            
            <div className="staff-activity-container">
            {/* Staff Details */}
            <div className={`form-group-review-requisition ${isEditable ? 'editable' : ''}`}>
            <h3>Staff Details</h3>
              <div className="form-field">
                <label htmlFor="staffName"><strong>Staff Name:</strong></label>
                <div className="input-container">
                  <input
                    type="text"
                    id="staffName"
                    name="staffName"
                    value={formData.staffName}
                    onChange={handleChange}
                    readOnly
                    className="read-only"
                  />
                  
                </div>
                {comments.staffName?.visible && (
                  <input
                    type="text"
                    name="staffNameComment"
                    value={comments.staffName.text || ''}
                    onChange={(e) => handleCommentChange('staffName', e.target.value)}
                    placeholder="Type your comment here..."
                    className="comment-textarea"
                  />
                )}
              </div>
              <div className="form-field">
                <label htmlFor="staffLevel"><strong>Staff Level:</strong></label>
                <div className="input-container">
                  <input
                    type="text"
                    id="staffLevel"
                    name="staffLevel"
                    value={formData.staffLevel}
                    onChange={handleChange}
                    readOnly
                    className="read-only"
                  />
                  
                </div>
                {comments.staffLevel?.visible && (
                  <input
                    type="text"
                    name="staffLevelComment"
                    value={comments.staffLevel.text || ''}
                    onChange={(e) => handleCommentChange('staffLevel', e.target.value)}
                    placeholder="Type your comment here..."
                    className="comment-textarea"
                  />
                )}
              </div>

              <div className="form-field">
                <label htmlFor="supervisorName"><strong>Supervisor Name:</strong></label>
                <div className="input-container">
                  <input
                    type="text"
                    id="supervisorName"
                    name="supervisorName"
                    value={formData.supervisorName}
                    onChange={handleChange}
                    readOnly
                    className="read-only"
                  />
                 
                </div>
                {comments.supervisorName?.visible && (
                  <input
                    type="text"
                    name="supervisorNameComment"
                    value={comments.supervisorName.text || ''}
                    onChange={(e) => handleCommentChange('supervisorName', e.target.value)}
                    placeholder="Type your comment here..."
                    className="comment-textarea"
                  />
                )}
              </div>

              <div className="form-field">
                <label htmlFor="userType"><strong>User Type:</strong></label>
                <div className="input-container">
                  <input
                    type="text"
                    id="userType"
                    name="userType"
                    value={formData.userType}
                    onChange={handleChange}
                    readOnly
                    className="read-only"
                  />
                  
                </div>
                {comments.userType?.visible && (
                  <input
                    type="text"
                    name="userTypeComment"
                    value={comments.userType.text || ''}
                    onChange={(e) => handleCommentChange('userType', e.target.value)}
                    placeholder="Type your comment here..."
                    className="comment-textarea"
                  />
                )}
              </div>
            </div>

           {/* Activity Details - Note: This uses 'form-group' not 'form-group-review-requisition' */}
          <div className={`form-group ${isEditable ? 'editable' : ''}`}>
            <h3>Activity Details</h3>
                        <div className="form-field">
              <div className="field-container">
                <label>Activity Duration</label>   
                <div className="date-input-container">
               <label>From:</label>
               <div className="date-input-wrapper">
                    <input
                     disabled={!isEditable}
                      type="date"
                      id="review-from"
                      name="from"
                      value={formData.from}
                      onChange={handleChange}
                    />
                    
                    <i className="fas fa-calendar-alt"></i>
                  </div>
                  
                  </div>
                
                <div className="date-input-container">
                <label>To:</label>
                <div className="date-input-wrapper">
                <input
                     disabled={!isEditable}
                      type="date"
                      id="review-to"
                      name="to"
                      value={formData.to}
                      onChange={handleChange}
                    />
                  <i className="fas fa-calendar-alt"></i>

                  </div>
                </div>
               </div>
               
              </div>
              <div className="form-field">
                <label htmlFor="activityName"><strong>Activity Name:</strong></label>
                <div className="input-container">
                  <input
                    disabled={!isEditable}
                    type="text"
                    id="activityName"
                    name="activityName"
                    value={formData.activityName}
                    onChange={handleChange}
                  />
                  
                </div>
                
              </div>
              

              <div className="form-field">
                <label htmlFor="activityPurpose"><strong>Activity Purpose:</strong></label>
                <div className="input-container">
                  <input
                    disabled={!isEditable}
                    type="text"
                    id="activityPurpose"
                    name="activityPurpose"
                    value={formData.activityPurpose}
                    onChange={handleChange}
                  />
                  
                </div>
                
              </div>

              <div className="form-field">
                <label htmlFor="targetClient"><strong>Target Client:</strong></label>
                <div className="input-container">
                  <input
                    disabled={!isEditable}
                    type="text"
                    id="targetClient"
                    name="targetClient"
                    value={formData.targetClient}
                    onChange={handleChange}
                  />
                  
                </div>
                
              </div>

              <div className="form-field">
                <label htmlFor="expectedImpact"><strong>Expected Impact:</strong></label>
                <div className="input-container">
                  <input
                    disabled={!isEditable}
                    type="text"
                    id="expectedImpact"
                    name="expectedImpact"
                    value={formData.expectedImpact}
                    onChange={handleChange}
                  />
                  
                </div>
                
              </div>

              <div className="form-group-review-requisition">
                {Array.isArray(formData.districtAndAreaProgramPairs) && formData.districtAndAreaProgramPairs.length > 0 ? (
                  formData.districtAndAreaProgramPairs.map((pair, index) => (
                    <div key={index} className="field-container">
                      <div className="vertical-field-container">
                      <div className="form-field">
                        <label>District</label>
                        <Select
                          disabled={!isEditable}
                          options={districtOptions}
                          value={districtOptions.find(
                            (option) => option.value === pair.district
                          )}
                          onChange={(selectedOption) =>
                            handleDistrictChange(index, selectedOption)
                          }
                          placeholder="Select District"
                          isClearable
                          className="custom-select-control district-select"
                        />
                      </div>



                      <div className="form-field">
                        <label>Area Program (AP)</label>
                        <input
                          disabled={!isEditable}
                          type="text"
                          value={pair.areaProgram || ''}
                          onChange={(e) =>
                            handleAreaProgramChange(index, e.target.value)
                          }
                          placeholder="Enter Area Program"
                        />
                        </div>
                      </div>
                      {/* "+" button for the first pair */}
                      {index === 0 && (
                        <button
                          type="button"
                          className="add-button"
                          onClick={addDistrictAPPair}
                        >
                          +
                        </button>
                      )}
                      {/* "X" button for all pairs except the first one */}
                      {index > 0 && (
                        <button
                          type="button"
                          className="remove-button"
                          onClick={() => removeDistrictAPPair(index)}
                        >
                          X
                        </button>
                      )}
                    </div>
                  ))
                ) : (
                  <div>
                    <p>No district and area program pairs available.</p>
                    <button
                      disabled={!isEditable}
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        setFormData({
                          ...formData,
                          districtAndAreaProgramPairs: [{ id: null, district: "", areaProgram: "" }]
                        });
                      }}
                    >
                      Add District & Area Program Pair
                    </button>
                  </div>
                )}
              </div>
            
              <div className="form-field">
                <label htmlFor="hubOffice"><strong>Hub Office:</strong></label>
                <div className="input-container">
                  <input
                    disabled={!isEditable}
                    type="text"
                    id="hubOffice"
                    name="hubOffice"
                    value={formData.hubOffice}
                    onChange={handleChange}
                  />
                  
                </div>
                
              </div>
                           
             <div className="form-field">
                <label htmlFor="status"><strong>Status:</strong></label>
                <div className="input-container">
                  <input
                    type="text"
                    id="Status" 
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    readOnly
                    className="read-only"

                  />
                  
                </div>
                
              </div>

              
        </div>

             {/* Project & Advance Details */}
            <div className={`form-group-review-requisition ${isEditable ? 'editable' : ''}`}>
              <h3>Project & Advance Details</h3>
                <div className="form-field">
                  <label htmlFor="projectCode"><strong>Project Code:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="projectCode"
                      name="projectCode"
                      value={formData.projectCode}
                      onChange={handleChange}
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="projectName"><strong>Project Name:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="projectName"
                      name="projectName"
                      value={formData.projectName}
                      onChange={handleChange}
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="budgetLineCode"><strong>Budget Line Code:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="budgetLineCode"
                      name="budgetLineCode"
                      value={formData.budgetLineCode}
                      onChange={handleChange}
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="payMode"><strong>Pay Mode:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="payMode"
                      name="payMode"
                      value={formData.payMode}
                      onChange={handleChange}
                      readOnly
                      className="read-only"
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="bankName"><strong>Bank Name:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="bankName"
                      name="bankName"
                      value={formData.bankName}
                      onChange={handleChange}
                      readOnly
                      className="read-only"
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="accountNumber"><strong>Account Number:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      value={formData.accountNumber}
                      onChange={handleChange}
                      readOnly
                      className="read-only"
                    />
                    
                  </div>
                  
                </div>

                <div className="form-field">
                  <label htmlFor="phoneNumber"><strong>Phone Number:</strong></label>
                  <div className="input-container">
                    <input
                      disabled={!isEditable}
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      readOnly
                      className="read-only"
                    />
                    
                  </div>
                  
                </div>
             </div>

             
            

            </div>
    
         



          </div>
        </div>
        
        {/* Blasting Cost Driver Table */}
        <div className="blasting-cost-drivers-section" style={{ marginTop: '20px', marginBottom: '20px' }}>
          

            <div id="blasting-div">
               <h3 id="blasting-heading">Blasting Cost Drivers</h3> 
            </div>

          {blastingCostItems && blastingCostItems.length > 0 ? (
              <div id="blasting-section">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Cost Driver</th>
                  <th>Justification</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                  <th>Support Documents</th>
                </tr>
              </thead>
              <tbody>
                {blastingCostItems && blastingCostItems.length > 0 ? (
                  blastingCostItems.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>
                        <div className="input-container d-flex align-items-center">
                          <span style={{ marginRight: '6px', fontWeight: 'bold' }}>{index + 1}.</span>
                          {item.isCustom ? (
                            <input
                              disabled={!isEditable}
                              type="text"
                              value={item.customCostDriver || ''}
                              onChange={(e) => {
                                const newItems = [...blastingCostItems];
                                newItems[index].customCostDriver = e.target.value;
                                setBlastingCostItems(newItems);
                                setHasChanges(true);
                              }}
                              placeholder="Type the blasting cost driver"
                              className="form-control blasting-cost-driver-name"
                            />
                          ) : (
                            <Select
                              isDisabled={!isEditable}
                              options={[
                                ...costDriverOptions.map((opt) => ({
                                  value: opt.costDriver,
                                  label: opt.costDriver,
                                })),
                                { value: 'Other', label: 'Other' }
                              ]}
                              value={
                                item.costDriver
                                  ? { value: item.costDriver, label: item.costDriver }
                                  : null
                              }
                              onChange={(selectedOption) => {
                                const newItems = [...blastingCostItems];
                                
                                if (!selectedOption) {
                                  Object.assign(newItems[index], {
                                    costDriver: "",
                                    isCustom: false,
                                    customCostDriver: "",
                                    supportDocuments: "",
                                    unitPrice: ""
                                  });
                                } else if (selectedOption.value === "Other") {
                                  Object.assign(newItems[index], {
                                    costDriver: "Other",
                                    isCustom: true,
                                    customCostDriver: "",
                                    supportDocuments: "",
                                    unitPrice: ""
                                  });
                                } else {
                                  const defaultUnitPrice = getDefaultUnitPrice(selectedOption.value);
                                  const supportDoc = getSupportDocuments(selectedOption.value);
                                  Object.assign(newItems[index], {
                                    costDriver: selectedOption.value,
                                    isCustom: false,
                                    customCostDriver: "",
                                    supportDocuments: supportDoc || "",
                                    unitPrice: defaultUnitPrice || ""
                                  });
                                  // Recalculate total
                                  const quantity = Number(newItems[index].quantity) || 0;
                                  const unitPrice = Number(defaultUnitPrice) || 0;
                                  newItems[index].total = quantity * unitPrice;
                                }
                                
                                setBlastingCostItems(newItems);
                                setHasChanges(true);
                              }}
                              isClearable
                              placeholder="Select Blasting Cost Driver"
                              className="custom-select-control"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                }),
                              }}
                            />
                          )}
                        </div>
                      </td>

                      <td>
                        <textarea
                          disabled={!isEditable}
                          value={item.justification || ''}
                          onChange={(e) => {
                            const newItems = [...blastingCostItems];
                            newItems[index].justification = e.target.value;
                            setBlastingCostItems(newItems);
                            setHasChanges(true);
                          }}
                          className="form-control"
                          rows="3"
                        />
                      </td>
                      <td>
                        <input
                          disabled={!isEditable}
                          type="text"
                          value={item.quantity === 0 || item.quantity === '' ? '' : Number(item.quantity).toLocaleString('en-US')}
                          onChange={(e) => {
                            const rawValue = e.target.value.replace(/,/g, '');
                            const newItems = [...blastingCostItems];
                            newItems[index].quantity = rawValue;
                            const quantity = Number(rawValue) || 0;
                            const unitPrice = Number(newItems[index].unitPrice) || 0;
                            newItems[index].total = quantity * unitPrice;
                            setBlastingCostItems(newItems);
                            setHasChanges(true);
                          }}
                          className="form-control"
                          id="blasting-table-quantity-input-box"
                        />
                      </td>
                      <td>
                        <input
                          disabled={!isEditable}
                          type="text"
                          value={item.unitPrice && item.unitPrice !== 0 && item.unitPrice !== '0' ? formatCurrency(item.unitPrice) : ''}
                          onChange={(e) => {
                            const rawValue = e.target.value.replace(/[^0-9.]/g, '');
                            const newItems = [...blastingCostItems];
                            newItems[index].unitPrice = rawValue;
                            const quantity = Number(newItems[index].quantity) || 0;
                            const unitPrice = Number(rawValue) || 0;
                            newItems[index].total = quantity * unitPrice;
                            setBlastingCostItems(newItems);
                            setHasChanges(true);
                          }}
                          className="form-control"
                        />
                      </td>           
                      <td>
                        <input
                          type="text"
                          value={item.total && item.total !== 0 ? formatCurrency(item.total) : ''}
                          readOnly
                          className="form-control read-only-input"
                        />
                      </td>
                      <td>
                        <textarea
                          disabled={!isEditable}
                          value={item.supportDocuments || ''}
                          onChange={(e) => {
                            const newItems = [...blastingCostItems];
                            newItems[index].supportDocuments = e.target.value;
                            setBlastingCostItems(newItems);
                            setHasChanges(true);
                          }}
                          className="form-control"
                          rows="3"
                        />
                      </td>
                        <td className="delete-cell">
                          <button
                            type="button"
                            className="btn btn-danger delete"
                            onClick={() => {
                              const newItems = blastingCostItems.filter((_, i) => i !== index);
                              setBlastingCostItems(newItems);
                              setHasChanges(true);
                            }}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center' }}>
                      No blasting cost drivers
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'right' }}>
                        <b>Blasting Total:</b>
                      </td>
                      
                      <td>
                        <div className="input-with-comment">
                          <input
                            type="text"
                            value={(() => {
                              const total = blastingCostItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0);
                              return total && total !== 0 ? formatCurrency(total) : '';
                            })()}
                            readOnly
                            id="total-total"
                            className="form-control read-only-input"
                          />
                          
                        </div>
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
        
            </table>
          </div>
        ) : (
          <div>
            <p>No blasting cost drivers</p>
          </div>
        )}

        {/* Add Row Button - Always visible */}
        {isEditable && (
          <button type="button" className="round-button" onClick={() => {
            setBlastingCostItems([
              ...blastingCostItems,
              { 
                costDriver: '', 
                isCustom: false,
                customCostDriver: '',
                justification: '', 
                quantity: '', 
                unitPrice: '', 
                total: '', 
                supportDocuments: '' 
              }
            ]);
            setHasChanges(true);
          }}>
            <i className="fas fa-plus"></i>
          </button>
        )}
      </div>



        {/* Cost Drivers Table */}
            <div id="blasting-div">
              <h3 id="blasting-heading">Other Cost Drivers</h3> 
            </div>
            
            {/* Check if costItems has any data */}
            {costItems && costItems.length > 0 ? (
                    <table className="table table-bordered">
                    <thead>
                        <tr>
                          <th>Cost Driver</th>
                          <th>Justification</th>
                          <th>Quantity</th>
                          <th>Unit Price</th>
                          <th>Total</th>
                          <th>Support Documents</th>
                      </tr>
                    </thead>
                    <tbody>
                      {costItems.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>
                            <div className="input-container d-flex align-items-center">
                              <span style={{ marginRight: '6px', fontWeight: 'bold' }}>{index + 1}.</span>
                              {item.isCustom ? (
                                <input
                                  
                                  type="text"
                                  value={item.customCostDriver}
                                  onChange={(e) => {
                                    const updatedItems = [...costItems];
                                    updatedItems[index].customCostDriver = e.target.value;
                                    setCostItems(updatedItems);
                                  }}
                                  placeholder="Type the Cost Driver"
                                  className="form-control"
                                />
                              ) : (
                                <Select
                                  disabled={!isEditable}
                                  options={
                                    costDriverOptions.map(opt => ({
                                      value: opt.costDriver,
                                      label: opt.costDriver
                                    }))
                                  }
                                  value={
                                    item.costDriver
                                      ? { value: item.costDriver, label: item.costDriver }
                                      : null
                                  }
                                  onChange={(selectedOption) => {
                                    const updatedItems = [...costItems];

                                    if (!selectedOption) {
                                      Object.assign(updatedItems[index], {
                                        costDriver: "",
                                        isCustom: false,
                                        customCostDriver: "",
                                        supportDocuments: "",
                                        unitPrice: ""
                                      });
                                      // Recalculate total
                                      const quantity = Number(updatedItems[index].quantity) || 0;
                                      const unitPrice = 0;
                                      updatedItems[index].total = quantity * unitPrice;
                                    } else if (selectedOption.value === "Other") {
                                      Object.assign(updatedItems[index], {
                                        costDriver: "",
                                        isCustom: true,
                                        customCostDriver: "",
                                        supportDocuments: "",
                                        unitPrice: ""
                                      });
                                      // Recalculate total
                                      const quantity = Number(updatedItems[index].quantity) || 0;
                                      const unitPrice = 0;
                                      updatedItems[index].total = quantity * unitPrice;
                                    } else {
                                      const defaultUnitPrice = getDefaultUnitPrice(selectedOption.value);
                                      Object.assign(updatedItems[index], {
                                        costDriver: selectedOption.value,
                                        isCustom: false,
                                        customCostDriver: "",
                                        supportDocuments: getSupportDocuments(selectedOption.value),
                                        unitPrice: defaultUnitPrice,
                                      });
                                      // Recalculate total with the new default unit price
                                      const quantity = Number(updatedItems[index].quantity) || 0;
                                      const unitPrice = Number(defaultUnitPrice) || 0;
                                      updatedItems[index].total = quantity * unitPrice;
                                    }

                                    setCostItems(updatedItems);
                                    setHasChanges(true);
                                  }}
                                  isClearable
                                  placeholder="Select Cost Driver"
                                  className="custom-select-control"
                                />

                                
                              )}
                            </div>
                          </td>

                          <td>
                            <div className="input-container">
                              <textarea
                                disabled={!isEditable}
                                value={item.justification || ''}
                                onChange={(e) => handleInputChange(index, 'justification', e.target.value)}
                                className="form-control"
                                rows="3"
                              />
                              
                            </div>
                          </td>
                          <td>
                            <div className="input-container">
                              <input
                                disabled={!isEditable}
                                type="text"
                                value={item.quantity === 0 || item.quantity === '' ? '' : Number(item.quantity).toLocaleString('en-US')}
                                onChange={(e) => {
                                  const rawValue = e.target.value.replace(/,/g, '');
                                  handleInputChange(index, 'quantity', rawValue);
                                }}
                                className="form-control quantity-input"
                              />
                              
                            </div>
                          </td>
                          <td>
                            <div className="input-container">
                              <input
                                disabled={!isEditable}
                                type="text"
                                value={formatCurrency(item.unitPrice)}
                                onChange={(e) => handleInputChange(index, 'unitPrice', e.target.value.replace(/[^0-9.]/g, ''))}
                                className="form-control"
                              />
                             
                            </div>
                          </td>
                          <td>
                            <div className="input-container">
                              <input
                                type="text"
                                value={item.total ? formatCurrency(item.total) : ''}
                                readOnly
                                className="form-control read-only-input"
                              />
                              
                            </div>
                          </td>
                          <td>
                            <div className="input-container">
                              <textarea
                                disabled={!isEditable}
                                value={item.supportDocuments === 'Type the support document' ? '' : item.supportDocuments}
                                onChange={(e) => handleInputChange(index, 'supportDocuments', e.target.value)}
                                className="form-control"
                                rows="3"
                                placeholder={item.costDriver === 'Other' ? 'Type the support document' : ''}
                              />
                              
                            </div>
                          </td>
                            <td className="delete-cell">
                              <button
                                type="button"
                                className="btn btn-danger delete"
                                onClick={() => removeRow(index)}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </td>
                          
                        </tr>
                      ))}
                      

                    </tbody>



                  <tfoot>
                    <tr>
                      <td colSpan="4" style={{ textAlign: 'right' }}>
                        <b>Other Cost Drivers Total:</b>
                      </td>
                      
                      <td>
                        <div className="input-with-comment">
                          <input
                            type="text"
                            value={formatCurrency(totalTotal)}
                            readOnly
                            id="total-total"
                            className="form-control read-only-input"
                          />
                          
                        </div>
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>

              </table>
              ) : (
                <div>
                  <p>No other cost drivers</p>
                </div>
              )}

              {/* Add Row Button - Always visible */}
              {isEditable && (
                <button type="button" className="round-button" onClick={() => {
                  const newRow = {
                    costDriver: '',
                    isCustom: false,
                    customCostDriver: '',
                    justification: '',
                    quantity: '',
                    unitPrice: '',
                    total: '',
                    supportDocuments: ''
                  };
                  setCostItems([...costItems, newRow]);
                  setHasChanges(true);
                }}>
                  <i className="fas fa-plus"></i>
                </button>
              )}

                        

                {/* Total Summary Section - Blasting Total + Other Cost Drivers Total */}
                      <div className="total-summary-section">
                          <div className="total-item">
                              <div className="total-item-label">Blasting Total</div>
                              <div className="total-item-value">{formatCurrency(blastingTotalTotal)}</div>
                          </div>
                          <div className="total-operator">+</div>
                          <div className="total-item">
                              <div className="total-item-label">Other Cost Drivers Total</div>
                              <div className="total-item-value">{formatCurrency(totalTotal)}</div>
                          </div>
                          <div className="total-operator">=</div>
                          <div className="grand-total-box">
                              <div className="grand-total-label">Grand Total</div>
                              <div className="grand-total-value">{formatCurrency(blastingTotalTotal + totalTotal)}</div>
                          </div>
                      </div>
                      <br/>
                      <br/>

                {/* Requester Comment Section - Display Only */}
                {formData.requesterComment && (
                  <div className="form-group-review-requisition">
                    <h3>Comment from Requestor</h3>
                    <div className="form-field">
                      <div 
                        className="requester-comment-display"
                        style={{
                          padding: '12px',
                          border: '1px solid #ddd',
                          borderRadius: '5px',
                          backgroundColor: '#f9f9f9',
                          minHeight: '80px',
                          whiteSpace: 'pre-wrap',
                          wordWrap: 'break-word',
                          lineHeight: '1.5',
                          color: '#555'
                        }}
                      >
                        {formData.requesterComment}
                      </div>
                    </div>
                  </div>
                )}

                
                <PopupModal
                isVisible={showHistory}
                onClose={() => setShowHistory(false)}
                title="Requisition History"
                titleStyle="modal-title"
                icon={faHistory}
                iconBorder="icon-circle"
              >
                <div className="timeline">
                  {console.log("Combined History:", combinedHistory)}
                {
                combinedHistory.map((entry, idx) => (
                  entry.field === "Status" && (
                    <div key={idx} className="timeline-entry">
                      <div>
                        <strong>Stage {entry.step || idx + 1}: </strong>
                        <div className={`badge ${getStatusClass(entry.newValue)}`}>
                          {entry.newValue}
                        </div>
                        <div><small>By {entry.changedBy} on {new Date(entry.dateChanged).toLocaleString()}</small></div>
                      </div>
                    </div>
                  )
                ))}

                  <hr/>
                </div>
              </PopupModal>

                <PopupModal
                  isVisible={showHistory}
                  onClose={() => setShowHistory(false)}
                  title="Requisition History"
                  titleStyle="modal-title"
                  icon={faHistory}
                  iconBorder="icon-circle"
                >
                  <div className="timeline">
                  {combinedHistory.map((entry, idx) => (
                    <div key={idx} className="timeline-entry">
                      <p>
                        <strong>Stage {entry.step}: </strong> 
                      
                      <div className={`badge ${getStatusClass(entry.status)}`}>
                        {entry.status}
                      </div>
                      </p>
                    </div>
                  ))}
                  <hr/>
                </div>
                </PopupModal>

          <div className="forward-confirm-wrapper">
            <PopupModal
              isVisible={showForwardConfirm}
              onClose={() => setShowForwardConfirm(false)}
              className="forward-confirm-modal"
              title={`Forward to ${selectedUser?.fullName}?`}
              titleStyle="modal-title"
              message={`Are you sure you want to forward this requisition to ${selectedUser?.fullName}?`}
              icon={faPaperPlane}
              iconBorder="icon-circle"
              footer={null}
            >
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  onClick={async () => {
                    setShowForwardConfirm(false);
                    try {
                      await axios.put(
                        `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/forward`,
                        { nextReviewerId: forwardTo },
                        { headers: { Authorization: `Bearer ${token}` } }
                      );

                      await axios.put(
                        `${process.env.REACT_APP_API_BASE_URL}/requisition/${requisitionID}/status`,
                        {
                          Status: "To be disbursed",
                          ReviewersId: currentUser.id,
                          NextReviewerId: "",
                          RequesterID: formData.userId,
                          RequesterName: formData.staffName,
                          SendNotificationToNextReviewer: false
                        },
                        { headers: { Authorization: `Bearer ${token}` } }
                      );

                      setForwardedToName(selectedUser.fullName);
                      setShowForwardSuccess(true);

                    } catch (err) {
                      console.error("Forward or status update failed", err);
                      alert("Could not forward. Try again.");
                    }
                  }}
                >
                  Yes, Forward
                </button>

                <button
                  className="btn btn-secondary mr-2"
                  onClick={() => setShowForwardConfirm(false)}
                >
                  Cancel
                </button>
              </div>
        </PopupModal>


      </div>


      <PopupModal
        isVisible={showForwardSuccess}
        title="Forwarded"
        titleStyle="success-title"
        message={`This requisition has been forwarded to ${forwardName}.`}
        icon={faCheckCircle}
        iconBorder="icon-circle"

        confirmText="OK"
        onConfirm={() => {
          setShowForwardSuccess(false);
          navigate("/staff-requisitions", {
            state: { defaultTab: "Approved" }
          });
        }}

        onClose={() => {
          setShowForwardSuccess(false);
          navigate("/staff-requisitions", {
            state: { defaultTab: "Approved" }
          });
        }}
      />
    
                   
    <PopupModal
      title="Sent Successfully"
      titleStyle = "success-title"
      message={`This requisition has been sent ${forwardedToReviewerName}.`}
      icon={faCheckCircle}
      isVisible={showModal}
      onClose={handleModalClose}
      iconBorder="popup-modal-icon"
    />        


    {/* Approve button for Reviewer 2 and 3 */}
    {formData.status !== "Approved" && canApprove && (reviewerNumber === 2 || reviewerNumber === 3) && (
      <div>
        {/* Confirmation Checkbox */}
        <div className="checkbox-container">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={isConfirmed}
              onChange={handleCheckboxChange}
              className="checkbox"
            />
            I confirm that I have reviewed this requisition.
          </label>
        </div>

        {isConfirmed && (
          <div className="signature-container">
            <div className="signed-by-label">Signed by:</div>
            <img
              src={signatureUrl}
              alt="User Signature"
              className="signature-image"
            />
            <div className="user-full-name">{fullName}</div>
            <br />

            <div className="form-group horizontal-group">
              <label htmlFor="nextReviewerId" className="form-label">
                Next Reviewer:
              </label>
              <select
                name="nextReviewerId"
                id="nextReviewerId"
                value={formData.nextReviewerId}
                onChange={handleChange}
                className="custom-select-field"
              >
                {!formData.nextReviewerId && (
                  <option value="" disabled>
                    Select Next Reviewer
                  </option>
                )}
                {reviewers
                  .filter(r => r.reviewerNumber !== formData.currentReviewerNumber)
                  .map(r => (
                    <option key={r.id} value={r.id}>
                      {r.firstName} {r.lastName}
                    </option>
                  ))}
              </select>
              {/* Trying */}
            <button onClick={handleNextReviewerClick} className="btn-send">
                    Send <i className="fas fa-arrow-right ml-1"></i>
            </button>
              
            </div>



            
                    



            {formData.userType === "Reviewer" && (
              <>
              
                <button
                  onClick={handleApproveClick}
                  className="btn btn-primary"
                >
                  Approve <i id="approve-icon" className="fas fa-check-circle"></i>
                </button>
                <br/>
                <br/>
              </>
            )}

            <DisapproveButton requisitionId={requisitionID} />
          </div>
        )}
      </div>
    )}

              {formData.status !== "Approved" && canApprove === false && reviewerNumber !== 1 && (
                  <div>
                    
                    {/* Confirmation Checkbox */}
                    <div className="checkbox-container">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={isConfirmed}
                          onChange={handleCheckboxChange}
                          className="checkbox"
                        />
                        I confirm that I have reviewed this requisition.
                      </label>
                    </div>

              {/* I think this is the one that Surrender Reviewers See */}
                    {isConfirmed && (
                      <div className="signature-container">
                        <div className="signed-by-label">Signed by:</div>
                        <img
                          src={signatureUrl}
                          alt="User Signature"
                          className="signature-image"
                        />
                        <div className="user-full-name">{fullName}</div>
                        <br />

                        
                        {/* Look for this section in your JSX (around line 1800-1900) */}
                        <div className="form-group horizontal-group">
                          <label htmlFor="nextReviewerId" className="form-label">
                            The Next Reviewer:
                          </label>
                          <select
                            name="nextReviewerId"
                            id="nextReviewerId"
                            value={selectedSurrenderReviewer}
                            onChange={(e) => {
                              const reviewerId = e.target.value;
                              console.log("Dropdown changed - selected ID:", reviewerId);
                              setSelectedSurrenderReviewer(reviewerId);
                              // ALSO update formData.nextReviewerId
                              setFormData(prev => ({ 
                                ...prev, 
                                nextReviewerId: reviewerId  // Keep as string or convert: Number(reviewerId)
                              }));
                              console.log("Updated formData.nextReviewerId to:", reviewerId);
                            }}
                            className="custom-select-field"
                          >
                            {!selectedSurrenderReviewer && (
                              <option value="" disabled>
                                Select Next Reviewer
                              </option>
                            )}
                            {reviewers
                              .filter(r => r.reviewerNumber !== formData.currentReviewerNumber)
                              .map(r => (
                                <option key={r.id} value={r.id}>
                                  {r.firstName} {r.lastName}
                                </option>
                              ))}
                          </select>
                          <button onClick={handleNextReviewerClick} className="btn-send">
                            Send <i className="fas fa-arrow-right ml-1"></i>
                          </button>
                        </div>


                    
                        <button
                          onClick={handleApproveClick}
                          className="btn btn-primary"
                        >
                          Approve <i id="approve-icon" className="fas fa-check-circle"></i>
                        </button>
                        <br/>
                               
                                    
                        <DisapproveButton requisitionId={requisitionID} />
                      </div>
                    )}
                  </div>
                )}
                
                


                {}


                

            { reviewerNumber === 1
              && formData.currentReviewerNumber === 1
              && theUserId !== formData.userId
              && formData.status !== "Approved" && (
                  <div>
                    
                    <div className="checkbox-container">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={isConfirmed}
                        onChange={handleCheckboxChange}
                        className="checkbox"
                      />
                      I confirm that I have checked this requisition.
                    </label>
                  </div>

                  {isConfirmed && (
                    <div className="signature-container">
                      <div className="signed-by-label">Signed by:</div>
                      <img
                        src={signatureUrl}
                        alt="User Signature"
                        className="signature-image"
                      />
                      <div className="user-full-name">{fullName}</div>
                      <br/>
                    
                    <div className="form-group horizontal-group">
                      <label htmlFor="nextReviewerId" className="form-label">
                      Next Reviewer:
                    </label>
                    <select
                      name="nextReviewerId"
                      id="nextReviewerId"
                      value={formData.nextReviewerId}
                      onChange={handleChange}
                      className="custom-select-field"
                    >
                      {!formData.nextReviewerId && (
                        <option value="" disabled>
                          Select Next Reviewer
                        </option>
                      )}

                     {reviewers
                      .filter(reviewer => reviewer.id.toLowerCase() !== theUserId.toLowerCase())
                      .map(reviewer => (
                        <option key={reviewer.id} value={reviewer.id}>
                          {reviewer.firstName} {reviewer.lastName} 
                        </option>
                      ))}
                    </select>

                        <button onClick={handleNextReviewerClick} className="btn-send">
                          Send <i className="fas fa-arrow-right ml-1"></i>
                        </button>
                      </div>
                      <DisapproveButton requisitionId={requisitionID} />

                    
                     </div>
                  )}
                  </div>

                  
                  
                )}
                

                  {/* The surrender reviewer checkbox section */}
                  {showSurrenderCheckbox && (
                    <div className="surrender-reviewer-section mt-4 p-3 border rounded">
                      <div className="form-check mb-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="surrenderCheckbox"
                          checked={isSurrenderChecked}
                          onChange={(e) => setIsSurrenderChecked(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="surrenderCheckbox">
                          <strong>Forward to Regular Reviewer</strong>
                        </label>
                      </div>

                      {isSurrenderChecked && (
  <div className="surrender-dropdown-section">
    <label htmlFor="surrenderReviewerSelect" className="form-label">
      <strong>Send to Reviewer:</strong>
    </label>
    <select
      id="surrenderReviewerSelect"
      className="form-select mb-3"
      value={selectedSurrenderReviewer}
      onChange={(e) => {
        console.log("Selected reviewer ID:", e.target.value);
        console.log("Current user ID:", theUserId);
        console.log("Are they the same (case-insensitive)?", 
          e.target.value.toLowerCase() === theUserId.toLowerCase() ? "YES - would be filtered out" : "NO - different users");
        setSelectedSurrenderReviewer(e.target.value);
      }}
    >
      <option value="">Select a reviewer...</option>
      {reviewers
        .filter(reviewer => reviewer.id !== theUserId)
        .map(reviewer => (
          <option key={reviewer.id} value={reviewer.id}>
            {reviewer.firstName} {reviewer.lastName} 
          </option>
      ))}
    </select>

    <button
      type="button"
      className="btn btn-primary"
      onClick={handleSurrenderNextReviewer}
      disabled={!selectedSurrenderReviewer || isSubmitting}
    >
      {isSubmitting ? "Sending..." : "Send to Selected Reviewer"}
    </button>
    <br/><br/><br/><br/><br/><br/>
    {/* Test endpoint button - remove in production */}
    <button 
      onClick={testSurrenderEndpoint}
      style={{ marginLeft: '10px', padding: '5px 10px', backgroundColor: '#f0f0f0' }}
    >
      Test Endpoint
    </button>
  </div>

)}
                    </div>
                  )}


                  
                    



        </form>
    </div>
</div>
<PopupModal
            isVisible={showHistory}
            onClose={() => setShowHistory(false)}
            title="Requisition History"
            titleStyle="modal-title"
            icon={faHistory}
            iconBorder="icon-circle"
          >
            <div className="timeline">
            {combinedHistory.map((entry, idx) => (
              <div key={idx} className="timeline-entry">
                <p>
                  <strong>Stage {entry.step}: </strong> 
                
                <div className={`badge ${getStatusClass(entry.status)}`}>
                   {entry.status}
                </div>
                </p>
              </div>
            ))}
            <hr/>
          </div>
          </PopupModal>


        <PopupModal
          title="Checked"
          titleStyle = "success-title"
          message="This requisition has been sent to the next reviewer."
          icon={faCheckCircle}
          isVisible={showCheckedRequisitionModal}
          onClose={handleCheckedRequisitionModalClose}
          iconBorder="popup-modal-icon"
        />

        <PopupModal
          title="Reviewed"
          titleStyle = "success-title"
          message="This requisition has been sent to the next reviewer."
          icon={faCheckCircle}
          isVisible={showReviewedRequisitionModal}
          onClose={handleReviewedRequisitionModalClose}
          iconBorder="popup-modal-icon"
        />


        <PopupModal
          title="Requisition Approved"
          titleStyle = "success-title"
          message="This requisition has been approved and sent to the next reviewer for funds disbursment."
          icon={faCheckCircle}
          isVisible={showApprovedModal}
          onClose={handleApprovedModalClose}
          iconBorder="popup-modal-icon"
        />

        <PopupModal
          title="Error"
          titleStyle = "error-title"
          message="Error. You might have no internet connection. Try again."
          icon={faTimesCircle}
          iconColor="red"
          isVisible={showErrorModal}
          onClose={handleErrorModalClose}
          iconBorder="x-icon"
        />

        <PopupModal
          title="No Internet Connection"
          message="Please check your internet connection and try again."
          icon={faWifi}
          isVisible={showNoInternetModal}
          onClose={handleNoInternetModalClose}
          iconBorder="x-icon"
        />

        <PopupModal
          title="Disbursed"
          titleStyle="success-title"
          message="Funds have been disbursed for this requisition."
          icon={faDollarSign}
          isVisible={showDisbursedModal}
          onClose={() => {
            setShowDisbursedModal(false);
            navigate("/staff-requisitions", {
              state: { defaultTab: "Approved" }
            });
          }}
          iconBorder="popup-modal-icon"
        />

        <PopupModal
          title="Who is the next reviewer?"
          titleStyle="error-title"
          message="Please select the next reviewer and then click the Send button."
          icon={faQuestionCircle}
          isVisible={showselectNextReviewerModal}
          onClose={() => {
            setShowselectNextReviewerModal(false);
          }}
          iconBorder="popup-modal-icon"
        />

        <PopupModal
          title="Who is the next reviewer?"
          titleStyle="error-title"
          message="Please select the next reviewer first, and then click the Approve button."
          icon={faQuestionCircle}
          isVisible={showNextReviewerBeforeApprovingModal}
          onClose={() => {
            setShowNextReviewerBeforeApprovingModal(false);
          }}
          iconBorder="popup-modal-icon"
        />


        

        </div>
        {/* End of container-fluid */}














        

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}

      
           
          
          
        </div>

  );
   
};

export default ReviewRequisition;
